import WarningLogoYellow from '../assets/images/WarningLogoYellow.png';
import WarningLogoGreen from '../assets/images/WarningLogoGreen.png';
import WarningLogoRed from '../assets/images/WarningLogoRed.png';
import WarningLogoModerateHigh from '../assets/images/WarningLogoModerateHigh.png';
import WarningLogoModerateLow from '../assets/images/WarningLogoModerateLow.png';

const countries = [
  { code: 'AD', label: 'Andorra', phone: '376' },
  { code: 'AE', label: 'United Arab Emirates', phone: '971' },
  { code: 'AF', label: 'Afghanistan', phone: '93' },
  { code: 'AG', label: 'Antigua and Barbuda', phone: '1-268' },
  { code: 'AI', label: 'Anguilla', phone: '1-264' },
  { code: 'AL', label: 'Albania', phone: '355' },
  { code: 'AM', label: 'Armenia', phone: '374' },
  { code: 'AO', label: 'Angola', phone: '244' },
  { code: 'AQ', label: 'Antarctica', phone: '672' },
  { code: 'AR', label: 'Argentina', phone: '54' },
  { code: 'AS', label: 'American Samoa', phone: '1-684' },
  { code: 'AT', label: 'Austria', phone: '43' },
  { code: 'AU', label: 'Australia', phone: '61', suggested: true },
  { code: 'AW', label: 'Aruba', phone: '297' },
  { code: 'AX', label: 'Aland Islands', phone: '358' },
  { code: 'AZ', label: 'Azerbaijan', phone: '994' },
  { code: 'BA', label: 'Bosnia and Herzegovina', phone: '387' },
  { code: 'BB', label: 'Barbados', phone: '1-246' },
  { code: 'BD', label: 'Bangladesh', phone: '880' },
  { code: 'BE', label: 'Belgium', phone: '32' },
  { code: 'BF', label: 'Burkina Faso', phone: '226' },
  { code: 'BG', label: 'Bulgaria', phone: '359' },
  { code: 'BH', label: 'Bahrain', phone: '973' },
  { code: 'BI', label: 'Burundi', phone: '257' },
  { code: 'BJ', label: 'Benin', phone: '229' },
  { code: 'BL', label: 'Saint Barthelemy', phone: '590' },
  { code: 'BM', label: 'Bermuda', phone: '1-441' },
  { code: 'BN', label: 'Brunei Darussalam', phone: '673' },
  { code: 'BO', label: 'Bolivia', phone: '591' },
  { code: 'BR', label: 'Brazil', phone: '55' },
  { code: 'BS', label: 'Bahamas', phone: '1-242' },
  { code: 'BT', label: 'Bhutan', phone: '975' },
  { code: 'BV', label: 'Bouvet Island', phone: '47' },
  { code: 'BW', label: 'Botswana', phone: '267' },
  { code: 'BY', label: 'Belarus', phone: '375' },
  { code: 'BZ', label: 'Belize', phone: '501' },
  { code: 'CA', label: 'Canada', phone: '1', suggested: true },
  { code: 'CC', label: 'Cocos (Keeling) Islands', phone: '61' },
  { code: 'CD', label: 'Congo, Democratic Republic of the', phone: '243' },
  { code: 'CF', label: 'Central African Republic', phone: '236' },
  { code: 'CG', label: 'Congo, Republic of the', phone: '242' },
  { code: 'CH', label: 'Switzerland', phone: '41' },
  { code: 'CI', label: "Cote d'Ivoire", phone: '225' },
  { code: 'CK', label: 'Cook Islands', phone: '682' },
  { code: 'CL', label: 'Chile', phone: '56' },
  { code: 'CM', label: 'Cameroon', phone: '237' },
  { code: 'CN', label: 'China', phone: '86' },
  { code: 'CO', label: 'Colombia', phone: '57' },
  { code: 'CR', label: 'Costa Rica', phone: '506' },
  { code: 'CU', label: 'Cuba', phone: '53' },
  { code: 'CV', label: 'Cape Verde', phone: '238' },
  { code: 'CW', label: 'Curacao', phone: '599' },
  { code: 'CX', label: 'Christmas Island', phone: '61' },
  { code: 'CY', label: 'Cyprus', phone: '357' },
  { code: 'CZ', label: 'Czech Republic', phone: '420' },
  { code: 'DE', label: 'Germany', phone: '49', suggested: true },
  { code: 'DJ', label: 'Djibouti', phone: '253' },
  { code: 'DK', label: 'Denmark', phone: '45' },
  { code: 'DM', label: 'Dominica', phone: '1-767' },
  { code: 'DO', label: 'Dominican Republic', phone: '1-809' },
  { code: 'DZ', label: 'Algeria', phone: '213' },
  { code: 'EC', label: 'Ecuador', phone: '593' },
  { code: 'EE', label: 'Estonia', phone: '372' },
  { code: 'EG', label: 'Egypt', phone: '20' },
  { code: 'EH', label: 'Western Sahara', phone: '212' },
  { code: 'ER', label: 'Eritrea', phone: '291' },
  { code: 'ES', label: 'Spain', phone: '34' },
  { code: 'ET', label: 'Ethiopia', phone: '251' },
  { code: 'FI', label: 'Finland', phone: '358' },
  { code: 'FJ', label: 'Fiji', phone: '679' },
  { code: 'FK', label: 'Falkland Islands (Malvinas)', phone: '500' },
  { code: 'FM', label: 'Micronesia, Federated States of', phone: '691' },
  { code: 'FO', label: 'Faroe Islands', phone: '298' },
  { code: 'FR', label: 'France', phone: '33', suggested: true },
  { code: 'GA', label: 'Gabon', phone: '241' },
  { code: 'GB', label: 'United Kingdom', phone: '44' },
  { code: 'GD', label: 'Grenada', phone: '1-473' },
  { code: 'GE', label: 'Georgia', phone: '995' },
  { code: 'GF', label: 'French Guiana', phone: '594' },
  { code: 'GG', label: 'Guernsey', phone: '44' },
  { code: 'GH', label: 'Ghana', phone: '233' },
  { code: 'GI', label: 'Gibraltar', phone: '350' },
  { code: 'GL', label: 'Greenland', phone: '299' },
  { code: 'GM', label: 'Gambia', phone: '220' },
  { code: 'GN', label: 'Guinea', phone: '224' },
  { code: 'GP', label: 'Guadeloupe', phone: '590' },
  { code: 'GQ', label: 'Equatorial Guinea', phone: '240' },
  { code: 'GR', label: 'Greece', phone: '30' },
  {
    code: 'GS',
    label: 'South Georgia and the South Sandwich Islands',
    phone: '500',
  },
  { code: 'GT', label: 'Guatemala', phone: '502' },
  { code: 'GU', label: 'Guam', phone: '1-671' },
  { code: 'GW', label: 'Guinea-Bissau', phone: '245' },
  { code: 'GY', label: 'Guyana', phone: '592' },
  { code: 'HK', label: 'Hong Kong', phone: '852' },
  { code: 'HM', label: 'Heard Island and McDonald Islands', phone: '672' },
  { code: 'HN', label: 'Honduras', phone: '504' },
  { code: 'HR', label: 'Croatia', phone: '385' },
  { code: 'HT', label: 'Haiti', phone: '509' },
  { code: 'HU', label: 'Hungary', phone: '36' },
  { code: 'ID', label: 'Indonesia', phone: '62' },
  { code: 'IE', label: 'Ireland', phone: '353' },
  { code: 'IL', label: 'Israel', phone: '972' },
  { code: 'IM', label: 'Isle of Man', phone: '44' },
  { code: 'IN', label: 'India', phone: '91' },
  { code: 'IO', label: 'British Indian Ocean Territory', phone: '246' },
  { code: 'IQ', label: 'Iraq', phone: '964' },
  { code: 'IR', label: 'Iran, Islamic Republic of', phone: '98' },
  { code: 'IS', label: 'Iceland', phone: '354' },
  { code: 'IT', label: 'Italy', phone: '39' },
  { code: 'JE', label: 'Jersey', phone: '44' },
  { code: 'JM', label: 'Jamaica', phone: '1-876' },
  { code: 'JO', label: 'Jordan', phone: '962' },
  { code: 'JP', label: 'Japan', phone: '81', suggested: true },
  { code: 'KE', label: 'Kenya', phone: '254' },
  { code: 'KG', label: 'Kyrgyzstan', phone: '996' },
  { code: 'KH', label: 'Cambodia', phone: '855' },
  { code: 'KI', label: 'Kiribati', phone: '686' },
  { code: 'KM', label: 'Comoros', phone: '269' },
  { code: 'KN', label: 'Saint Kitts and Nevis', phone: '1-869' },
  { code: 'KP', label: "Korea, Democratic People's Republic of", phone: '850' },
  { code: 'KR', label: 'Korea, Republic of', phone: '82' },
  { code: 'KW', label: 'Kuwait', phone: '965' },
  { code: 'KY', label: 'Cayman Islands', phone: '1-345' },
  { code: 'KZ', label: 'Kazakhstan', phone: '7' },
  { code: 'LA', label: "Lao People's Democratic Republic", phone: '856' },
  { code: 'LB', label: 'Lebanon', phone: '961' },
  { code: 'LC', label: 'Saint Lucia', phone: '1-758' },
  { code: 'LI', label: 'Liechtenstein', phone: '423' },
  { code: 'LK', label: 'Sri Lanka', phone: '94' },
  { code: 'LR', label: 'Liberia', phone: '231' },
  { code: 'LS', label: 'Lesotho', phone: '266' },
  { code: 'LT', label: 'Lithuania', phone: '370' },
  { code: 'LU', label: 'Luxembourg', phone: '352' },
  { code: 'LV', label: 'Latvia', phone: '371' },
  { code: 'LY', label: 'Libya', phone: '218' },
  { code: 'MA', label: 'Morocco', phone: '212' },
  { code: 'MC', label: 'Monaco', phone: '377' },
  { code: 'MD', label: 'Moldova, Republic of', phone: '373' },
  { code: 'ME', label: 'Montenegro', phone: '382' },
  { code: 'MF', label: 'Saint Martin (French part)', phone: '590' },
  { code: 'MG', label: 'Madagascar', phone: '261' },
  { code: 'MH', label: 'Marshall Islands', phone: '692' },
  {
    code: 'MK',
    label: 'Macedonia, the Former Yugoslav Republic of',
    phone: '389',
  },
  { code: 'ML', label: 'Mali', phone: '223' },
  { code: 'MM', label: 'Myanmar', phone: '95' },
  { code: 'MN', label: 'Mongolia', phone: '976' },
  { code: 'MO', label: 'Macao', phone: '853' },
  { code: 'MP', label: 'Northern Mariana Islands', phone: '1-670' },
  { code: 'MQ', label: 'Martinique', phone: '596' },
  { code: 'MR', label: 'Mauritania', phone: '222' },
  { code: 'MS', label: 'Montserrat', phone: '1-664' },
  { code: 'MT', label: 'Malta', phone: '356' },
  { code: 'MU', label: 'Mauritius', phone: '230' },
  { code: 'MV', label: 'Maldives', phone: '960' },
  { code: 'MW', label: 'Malawi', phone: '265' },
  { code: 'MX', label: 'Mexico', phone: '52' },
  { code: 'MY', label: 'Malaysia', phone: '60' },
  { code: 'MZ', label: 'Mozambique', phone: '258' },
  { code: 'NA', label: 'Namibia', phone: '264' },
  { code: 'NC', label: 'New Caledonia', phone: '687' },
  { code: 'NE', label: 'Niger', phone: '227' },
  { code: 'NF', label: 'Norfolk Island', phone: '672' },
  { code: 'NG', label: 'Nigeria', phone: '234' },
  { code: 'NI', label: 'Nicaragua', phone: '505' },
  { code: 'NL', label: 'Netherlands', phone: '31' },
  { code: 'NO', label: 'Norway', phone: '47' },
  { code: 'NP', label: 'Nepal', phone: '977' },
  { code: 'NR', label: 'Nauru', phone: '674' },
  { code: 'NU', label: 'Niue', phone: '683' },
  { code: 'NZ', label: 'New Zealand', phone: '64' },
  { code: 'OM', label: 'Oman', phone: '968' },
  { code: 'PA', label: 'Panama', phone: '507' },
  { code: 'PE', label: 'Peru', phone: '51' },
  { code: 'PF', label: 'French Polynesia', phone: '689' },
  { code: 'PG', label: 'Papua New Guinea', phone: '675' },
  { code: 'PH', label: 'Philippines', phone: '63' },
  { code: 'PK', label: 'Pakistan', phone: '92' },
  { code: 'PL', label: 'Poland', phone: '48' },
  { code: 'PM', label: 'Saint Pierre and Miquelon', phone: '508' },
  { code: 'PN', label: 'Pitcairn', phone: '870' },
  { code: 'PR', label: 'Puerto Rico', phone: '1' },
  { code: 'PS', label: 'Palestine, State of', phone: '970' },
  { code: 'PT', label: 'Portugal', phone: '351' },
  { code: 'PW', label: 'Palau', phone: '680' },
  { code: 'PY', label: 'Paraguay', phone: '595' },
  { code: 'QA', label: 'Qatar', phone: '974' },
  { code: 'RE', label: 'Reunion', phone: '262' },
  { code: 'RO', label: 'Romania', phone: '40' },
  { code: 'RS', label: 'Serbia', phone: '381' },
  { code: 'RU', label: 'Russian Federation', phone: '7' },
  { code: 'RW', label: 'Rwanda', phone: '250' },
  { code: 'SA', label: 'Saudi Arabia', phone: '966' },
  { code: 'SB', label: 'Solomon Islands', phone: '677' },
  { code: 'SC', label: 'Seychelles', phone: '248' },
  { code: 'SD', label: 'Sudan', phone: '249' },
  { code: 'SE', label: 'Sweden', phone: '46' },
  { code: 'SG', label: 'Singapore', phone: '65' },
  { code: 'SH', label: 'Saint Helena', phone: '290' },
  { code: 'SI', label: 'Slovenia', phone: '386' },
  { code: 'SJ', label: 'Svalbard and Jan Mayen', phone: '47' },
  { code: 'SK', label: 'Slovakia', phone: '421' },
  { code: 'SL', label: 'Sierra Leone', phone: '232' },
  { code: 'SM', label: 'San Marino', phone: '378' },
  { code: 'SN', label: 'Senegal', phone: '221' },
  { code: 'SO', label: 'Somalia', phone: '252' },
  { code: 'SR', label: 'Suriname', phone: '597' },
  { code: 'SS', label: 'South Sudan', phone: '211' },
  { code: 'ST', label: 'Sao Tome and Principe', phone: '239' },
  { code: 'SV', label: 'El Salvador', phone: '503' },
  { code: 'SX', label: 'Sint Maarten (Dutch part)', phone: '1-721' },
  { code: 'SY', label: 'Syrian Arab Republic', phone: '963' },
  { code: 'SZ', label: 'Swaziland', phone: '268' },
  { code: 'TC', label: 'Turks and Caicos Islands', phone: '1-649' },
  { code: 'TD', label: 'Chad', phone: '235' },
  { code: 'TF', label: 'French Southern Territories', phone: '262' },
  { code: 'TG', label: 'Togo', phone: '228' },
  { code: 'TH', label: 'Thailand', phone: '66' },
  { code: 'TJ', label: 'Tajikistan', phone: '992' },
  { code: 'TK', label: 'Tokelau', phone: '690' },
  { code: 'TL', label: 'Timor-Leste', phone: '670' },
  { code: 'TM', label: 'Turkmenistan', phone: '993' },
  { code: 'TN', label: 'Tunisia', phone: '216' },
  { code: 'TO', label: 'Tonga', phone: '676' },
  { code: 'TR', label: 'Turkey', phone: '90' },
  { code: 'TT', label: 'Trinidad and Tobago', phone: '1-868' },
  { code: 'TV', label: 'Tuvalu', phone: '688' },
  { code: 'TW', label: 'Taiwan, Province of China', phone: '886' },
  { code: 'TZ', label: 'United Republic of Tanzania', phone: '255' },
  { code: 'UA', label: 'Ukraine', phone: '380' },
  { code: 'UG', label: 'Uganda', phone: '256' },
  { code: 'US', label: 'United States', phone: '1', suggested: true },
  { code: 'UY', label: 'Uruguay', phone: '598' },
  { code: 'UZ', label: 'Uzbekistan', phone: '998' },
  { code: 'VA', label: 'Holy See (Vatican City State)', phone: '379' },
  { code: 'VC', label: 'Saint Vincent and the Grenadines', phone: '1-784' },
  { code: 'VE', label: 'Venezuela', phone: '58' },
  { code: 'VG', label: 'British Virgin Islands', phone: '1-284' },
  { code: 'VI', label: 'US Virgin Islands', phone: '1-340' },
  { code: 'VN', label: 'Vietnam', phone: '84' },
  { code: 'VU', label: 'Vanuatu', phone: '678' },
  { code: 'WF', label: 'Wallis and Futuna', phone: '681' },
  { code: 'WS', label: 'Samoa', phone: '685' },
  { code: 'XK', label: 'Kosovo', phone: '383' },
  { code: 'YE', label: 'Yemen', phone: '967' },
  { code: 'YT', label: 'Mayotte', phone: '262' },
  { code: 'ZA', label: 'South Africa', phone: '27' },
  { code: 'ZM', label: 'Zambia', phone: '260' },
  { code: 'ZW', label: 'Zimbabwe', phone: '263' },
];
const CURRENCIES = [
  { currency: 'United States Dollar', code: 'USD', symbol: '$' },
  { currency: 'Euro', code: 'EUR', symbol: '€' },
  { currency: 'British Pound Sterling', code: 'GBP', symbol: '£' },
  { currency: 'Japanese Yen', code: 'JPY', symbol: '¥' },
  { currency: 'Australian Dollar', code: 'AUD', symbol: 'A$' },
  { currency: 'Canadian Dollar', code: 'CAD', symbol: 'C$' },
  { currency: 'Swiss Franc', code: 'CHF', symbol: 'Fr' },
  { currency: 'Chinese Yuan Renminbi', code: 'CNY', symbol: '¥' },
  { currency: 'Indian Rupee', code: 'INR', symbol: '₹' },
  { currency: 'South Korean Won', code: 'KRW', symbol: '₩' },
  { currency: 'Russian Ruble', code: 'RUB', symbol: '₽' },
  { currency: 'Brazilian Real', code: 'BRL', symbol: 'R$' },
  { currency: 'Mexican Peso', code: 'MXN', symbol: '$' },
  { currency: 'South African Rand', code: 'ZAR', symbol: 'R' },
  { currency: 'Saudi Riyal', code: 'SAR', symbol: '﷼' },
  { currency: 'United Arab Emirates Dirham', code: 'AED', symbol: 'د.إ' },
  { currency: 'Singapore Dollar', code: 'SGD', symbol: 'S$' },
  { currency: 'Hong Kong Dollar', code: 'HKD', symbol: 'HK$' },
  { currency: 'New Zealand Dollar', code: 'NZD', symbol: 'NZ$' },
  { currency: 'Swedish Krona', code: 'SEK', symbol: 'kr' },
  { currency: 'Norwegian Krone', code: 'NOK', symbol: 'kr' },
  { currency: 'Danish Krone', code: 'DKK', symbol: 'kr' },
  { currency: 'Turkish Lira', code: 'TRY', symbol: '₺' },
  { currency: 'Egyptian Pound', code: 'EGP', symbol: 'E£' },
  { currency: 'Argentine Peso', code: 'ARS', symbol: '$' },
  { currency: 'Colombian Peso', code: 'COP', symbol: '$' },
  { currency: 'Malaysian Ringgit', code: 'MYR', symbol: 'RM' },
  { currency: 'Thai Baht', code: 'THB', symbol: '฿' },
  { currency: 'Indonesian Rupiah', code: 'IDR', symbol: 'Rp' },
  { currency: 'Pakistani Rupee', code: 'PKR', symbol: '₨' },
  { currency: 'Nigerian Naira', code: 'NGN', symbol: '₦' },
  { currency: 'Kenyan Shilling', code: 'KES', symbol: 'KSh' },
  { currency: 'Swiss Franc', code: 'CHF', symbol: 'Fr' },
  { currency: 'New Taiwan Dollar', code: 'TWD', symbol: 'NT$' },
  { currency: 'Israeli New Shekel', code: 'ILS', symbol: '₪' },
  { currency: 'Qatari Riyal', code: 'QAR', symbol: '﷼' },
  { currency: 'Kuwaiti Dinar', code: 'KWD', symbol: 'د.ك' },
  { currency: 'Omani Rial', code: 'OMR', symbol: '﷼' },
  { currency: 'Bahraini Dinar', code: 'BHD', symbol: 'د.ب' },
];
const INITIATE_SEARCH_FIELDS = [
  { label: 'Name', value: 'name' },
  { label: 'Alias', value: 'aliases' },
  { label: 'Phone No.', value: 'phone_number' },
  { label: 'Email', value: 'email' },
  {
    label: 'Date Of Birth',
    value: 'date_of_birth',
  },
  {
    label: 'Date Of Establishment',
    value: 'date_of_birth',
  },
  {
    label: 'Vessel Manufacture Date',
    value: 'date_of_birth',
  },
  {
    label: 'Aircraft Manufacture Date',
    value: 'date_of_birth',
  },
  {
    label: 'Uploaded Name',
    value: 'uploadedName',
  },
  { label: 'Gender', value: 'gender' },

  {
    label: 'Country Of Jurisdiction',
    value: 'country_of_jurisdiction',
  },
  { label: 'City', value: 'city' },
  { label: 'State', value: 'state' },
  { label: 'Nationality', value: 'nationality' },

  {
    label: 'Applicant ID',
    value: 'applicant_id',
  },
  {
    label: 'Application ID',
    value: 'application_id',
  },
  {
    label: 'SDFC Lead ID',
    value: 'sdfc_lead_id',
  },
  { label: 'Branch Name', value: 'branch_name' },
  {
    label: 'Product Line',
    value: 'product_line',
  },
  {
    label: 'Pennant Analyst Name',
    value: 'pennant_analyst_name',
  },
  {
    label: 'Analyst Email ID',
    value: 'analyst_email_id',
  },
  {
    label: 'Manager Name',
    value: 'manager_name',
  },
  { label: 'KYCID', value: 'kycID' },
  {
    label: 'Account Number',
    value: 'account_number',
  },
  { label: 'IFSC Code/Bank ID/Bank ID', value: 'ifsc_code' },
  { label: 'Bank Name', value: 'bank_name' },

  { label: 'GST', value: 'gst' },
  {
    label: 'Passport Number',
    value: 'passport_number',
  },
  { label: 'National ID', value: 'national_id' },
  { label: 'PAN', value: 'pan' },
  {
    label: 'Drivers License',
    value: 'drivers_license',
  },
  { label: 'Voters ID', value: 'voters_id' },
  { label: 'ISIN', value: 'isin' },
  { label: 'CIN', value: 'cin' },
  { label: 'TIN', value: 'tin' },
  { label: 'SSN', value: 'ssn' },

  { label: 'Headquarter', value: 'headquarter' },
  {
    label: 'Registered Owner',
    value: 'registered_owner',
  },
  {
    label: 'Parent Company',
    value: 'parent_company',
  },
  { label: 'Vessel Type', value: 'vessel_type' },
  { label: 'IMO', value: 'imo' },
  { label: 'MMSI', value: 'mmsi' },
  { label: 'Flag State', value: 'flag_state' },
  { label: 'Operator', value: 'operator' },
  {
    label: 'Manufacture Serial Number',
    value: 'manufacture_serial_number',
  },
  {
    label: 'Construction Number',
    value: 'construction_number',
  },
  { label: 'Program', value: 'program' },
  {
    label: 'Aircraft Model',
    value: 'aircraft_model',
  },

  {
    label: 'Transaction ID',
    value: 'transaction_id',
  },
  {
    label: 'Transaction Type',
    value: 'transaction_type',
  },
  {
    label: 'Transaction Product Type',
    value: 'transaction_product_type',
  },
  { label: 'Party', value: 'party' },
  {
    label: 'Transaction Date',
    value: 'transaction_date',
  },
  { label: 'Amount', value: 'amount' },
  { label: 'Currency', value: 'currency' },
  { label: 'Channel', value: 'channel' },
  { label: 'Remarks/Comments', value: 'message_id' },
  {
    label: 'Bank Identifier Code',
    value: 'bank_identifier_code',
  },
  {
    label: 'Intermediary Bank Name',
    value: 'intermediary_bank_name',
  },
  {
    label: 'Postal Address',
    value: 'postal_address',
  },
  {
    label: 'Financial Institution ID',
    value: 'financial_institution_id',
  },

  {
    label: 'Other Fields',
    value: 'other_fields',
  },
  { label: 'Target Date', value: 'target_date' },
  { label: 'End Date', value: 'end_date' },
];

const days = [
  {
    value: 0,
  },
  {
    value: 20,
    label: '20 Days',
  },
  {
    value: 40,
    label: '40 Days',
  },
  {
    value: 60,
    label: '60 Days',
  },
  {
    value: 80,
    label: '80 Days',
  },
  {
    value: 100,
  },
];
const marks = [
  {
    value: 0,
  },
  {
    value: 20,
    label: '20%',
  },
  {
    value: 40,
    label: '40%',
  },
  {
    value: 60,
    label: '60%',
  },
  {
    value: 80,
    label: '80%',
  },
  {
    value: 99,
    label: '99%',
  },
];
const accountIds = ['aditya_birla', 'commonorg', 'orgsp', 'org1', 'allbank'];
const riskRatingMarks = [
  {
    value: 0,
  },
  {
    value: 10,
    label: '10',
  },
  {
    value: 20,
    label: '20',
  },
  {
    value: 30,
    label: '30',
  },
  {
    value: 40,
    label: '40',
  },
  {
    value: 50,
    label: '50',
  },
  {
    value: 60,
    label: '60',
  },
];
const reminderMailMarks = [
  {
    value: 0,
  },
  {
    value: 10,
    label: '10',
  },
  {
    value: 20,
    label: '20',
  },
  {
    value: 30,
    label: '30',
  },
  {
    value: 40,
    label: '40',
  },
  {
    value: 50,
    label: '50',
  },
  {
    value: 60,
    label: '60',
  },
];
const snoozingFrequencyMarks = [
  {
    value: 0,
  },
  {
    value: 4,
    label: '4',
  },
  {
    value: 8,
    label: '8',
  },
  {
    value: 12,
    label: '12',
  },
  {
    value: 16,
    label: '16',
  },
  {
    value: 20,
    label: '20',
  },
];
const alertBySamsMark = [
  {
    value: 0,
  },
  {
    value: 20,
    label: '20',
  },
  {
    value: 40,
    label: '40',
  },
  {
    value: 60,
    label: '60',
  },
  {
    value: 80,
    label: '80',
  },
  {
    value: 100,
    label: '100',
  },
];
const dobMarks = [
  {
    value: 3,
    label: '3m',
  },
  {
    value: 12,
    label: '12m',
  },
  {
    value: 24,
    label: '24m',
  },
  {
    value: 36,
    label: '36m',
  },
  {
    value: 48,
    label: '48m',
  },
  {
    value: 60,
    label: '60m',
  },
];

export const SEARCH_TYPES = {
  b: {
    key: 'b',
    label: 'Default',
  },
  i: {
    key: 'i',
    label: 'Individual',
  },
  e: {
    key: 'e',
    label: 'Entity',
  },
  v: {
    key: 'v',
    label: 'Vessel',
  },
  a: {
    key: 'a',
    label: 'Aircraft',
  },
};
const LEVELS = {
  0: 'Maker Level',
  1: 'Checker Level 1',
  2: 'Checker Level 2',
  3: 'Checker Level 3',
  4: 'Checker Level 4',
  5: 'Checker Level 5',
};

const SEARCH_TYPES_TRANSACTION = {
  b: {
    key: 'b',
    label: 'Default',
  },
  i: {
    key: 'i',
    label: 'Individual',
  },
  e: {
    key: 'e',
    label: 'Entity',
  },
};

export const SCREEN_TYPES = {
  i: {
    key: 'i',
    label: 'Initial',
  },
  o: {
    key: 'o',
    label: 'ongoing',
  },
};
const HISTORY_SCREEN_TYPES = {
  i: {
    key: SCREEN_TYPES.i.key,
    label: 'InitialScreening',
  },
  o: {
    key: SCREEN_TYPES.o.key,
    label: 'OngoingScreening',
  },
};
const ASSIGNED_OPTIONS = {
  a: {
    key: 'a',
    label: 'Alert',
  },
  na: {
    key: 'na',
    label: 'Non Alert',
  },
  n: {
    key: 'n',
    label: 'Nothing',
  },
  b: {
    key: 'b',
    label: 'Both',
  },
};

const FINAL_VERDICTS = {
  a: {
    key: 'a',
    label: 'Accepted',
  },
  r: {
    key: 'r',
    label: 'Rejected',
  },
};
export const EMPTY_FILTER_VALUES = ['', 'null', '[]'];

const LIST_TYPES = {
  s: {
    key: 's',
    label: 'Sanctions',
  },
  p: {
    key: 'p',
    label: 'PEP',
  },
  a: {
    key: 'a',
    label: 'AMS',
  },
  c: {
    key: 'c',
    label: 'Corporate',
  },
  l: {
    key: 'l',
    label: 'Legal',
  },
};
// ONGOING WITHOUT RISK RATING PERMISSION
const BULK_FILE_LIST_TYPE_COLUMNS = {
  i: [
    'S.no',
    'Full Name',
    'Gender',
    'D.O.B (yyyy-mm-dd)',
    'Nationality',
    'SSN',
    'Country 1',
    'Country 2',
    'Country 3',
    'Country 4',
    'Country of Jurisdiction',
    'Address 1',
    'Address 2',
    'Address 3',
    'Address 4',
    'City 1',
    'City 2',
    'City 3',
    'City 4',
    'State 1',
    'State 2',
    'State 3',
    'State 4',
    'ZIP Code 1',
    'ZIP Code 2',
    'ZIP Code 3',
    'ZIP Code 4',
    'Passport Number',
    'Voter ID',
    'Driving License',
    'Phone No',
    'Email',
    'PAN',
    'National ID',
    'Alias',
    'Ongoing Monitoring End date (yyyy-mm-dd)',
    'Applicant ID',
    'Application ID',
    'SDFC Lead ID',
    'Branch Name',
    'Product Line',
    'Pennant Analyst Name',
    'Analyst Email ID',
    'Field 1',
    'Field 2',
    'Field 3',
    'Field 4',
    'Field 5',
    'Field 6',
    'Field 7',
    'Field 8',
    'Field 9',
    'Field 10',
    'Field 11',
    'Field 12',
    'Field 13',
    'Field 14',
    'Field 15',
    'Field 16',
    'Field 17',
    'Field 18',
    'Field 19',
    'Field 20',
  ],
  e: [
    'S.no',
    'Org Name',
    'D.O.E (yyyy-mm-dd)',
    'Phone No',
    'Email',
    'Country 1',
    'Country 2',
    'Country 3',
    'Country 4',
    'Headquarters',
    'Country of Jurisdiction',
    'Address 1',
    'Address 2',
    'Address 3',
    'Address 4',
    'City 1',
    'City 2',
    'City 3',
    'City 4',
    'State 1',
    'State 2',
    'State 3',
    'State 4',
    'ZIP Code 1',
    'ZIP Code 2',
    'ZIP Code 3',
    'ZIP Code 4',
    'CIN',
    'GST',
    'ISIN',
    'TIN/PAN',
    'Alias',
    'Ongoing Monitoring End date (yyyy-mm-dd)',
    'Applicant ID',
    'Application ID',
    'SDFC Lead ID',
    'Branch Name',
    'Product Line',
    'Pennant Analyst Name',
    'Analyst Email ID',
    'Field 1',
    'Field 2',
    'Field 3',
    'Field 4',
    'Field 5',
    'Field 6',
    'Field 7',
    'Field 8',
    'Field 9',
    'Field 10',
    'Field 11',
    'Field 12',
    'Field 13',
    'Field 14',
    'Field 15',
    'Field 16',
    'Field 17',
    'Field 18',
    'Field 19',
    'Field 20',
  ],
  v: [
    'S.no',
    'Vessel Name',
    'Mfd date (yyyy-mm-dd)',
    'Vessel Type',
    'Country 1',
    'Country 2',
    'Country 3',
    'Country 4',
    'Flag State',
    'Country of Jurisdiction',
    'Registered Owner',
    'Parent Company',
    'Address 1',
    'Address 2',
    'Address 3',
    'Address 4',
    'City 1',
    'City 2',
    'City 3',
    'City 4',
    'State 1',
    'State 2',
    'State 3',
    'State 4',
    'ZIP Code 1',
    'ZIP Code 2',
    'ZIP Code 3',
    'ZIP Code 4',
    'IMO',
    'MMSI',
    'Alias',
    'Ongoing Monitoring End date (yyyy-mm-dd)',
  ],
  a: [
    'S.no',
    'Aircraft Name',
    'Mfd Date (yyyy-mm-dd)',
    'Program',
    'Country 1',
    'Country 2',
    'Country 3',
    'Country 4',
    'Aircraft Model',
    'Country of Jurisdiction',
    'Operator',
    'Address 1',
    'Address 2',
    'Address 3',
    'Address 4',
    'City 1',
    'City 2',
    'City 3',
    'City 4',
    'State 1',
    'State 2',
    'State 3',
    'State 4',
    'ZIP Code 1',
    'ZIP Code 2',
    'ZIP Code 3',
    'ZIP Code 4',
    'Manufacture Serial no',
    'Construction Number',
    'Alias',
    'Ongoing Monitoring End date (yyyy-mm-dd)',
  ],
  b: [
    'S.no',
    'Name',
    'Alias',
    'DOB/DOM/DOE(yyyy-mm-dd)',
    'Nationality',
    'Gender',
    'Country 1',
    'Country 2',
    'Country 3',
    'Country 4',
    'Country of Jurisdiction',
    'Address 1',
    'Address 2',
    'Address 3',
    'Address 4',
    'City 1',
    'City 2',
    'City 3',
    'City 4',
    'State 1',
    'State 2',
    'State 3',
    'State 4',
    'ZIP Code 1',
    'ZIP Code 2',
    'ZIP Code 3',
    'ZIP Code 4',
    'TIN/PAN',
    'Passport Number',
    'Voter ID',
    'Driving License',
    'National ID',
    'Phone No',
    'Email',
    'Headquarters',
    'CIN',
    'GST',
    'ISIN',
    'SSN',
    'Vessel Type',
    'Flag State',
    'MMSI',
    'Registered Owner',
    'Tonnage',
    'IMO',
    'Parent Company',
    'Program',
    'Aircraft Operator/Owner',
    'Aircraft Model',
    'Manufacture Serial no',
    'Construction Number',
    'Ongoing Monitoring End date (yyyy-mm-dd)',
    'Applicant ID',
    'Application ID',
    'SDFC Lead ID',
    'Branch Name',
    'Product Line',
    'Pennant Analyst Name',
    'Analyst Email ID',
    'Field 1',
    'Field 2',
    'Field 3',
    'Field 4',
    'Field 5',
    'Field 6',
    'Field 7',
    'Field 8',
    'Field 9',
    'Field 10',
    'Field 11',
    'Field 12',
    'Field 13',
    'Field 14',
    'Field 15',
    'Field 16',
    'Field 17',
    'Field 18',
    'Field 19',
    'Field 20',
  ],
};
// INITITALL WITHOUT RISK RATING
const BULK_INITIAL_FILE_LIST_TYPE_COLUMNS = {
  i: [
    'S.no',
    'Full Name',
    'Gender',
    'D.O.B (yyyy-mm-dd)',
    'Nationality',
    'SSN',
    'Country 1',
    'Country 2',
    'Country 3',
    'Country 4',
    'Country of Jurisdiction',
    'Address 1',
    'Address 2',
    'Address 3',
    'Address 4',
    'City 1',
    'City 2',
    'City 3',
    'City 4',
    'State 1',
    'State 2',
    'State 3',
    'State 4',
    'ZIP Code 1',
    'ZIP Code 2',
    'ZIP Code 3',
    'ZIP Code 4',
    'Passport Number',
    'Voter ID',
    'Driving License',
    'Phone No',
    'Email',
    'PAN',
    'National ID',
    'Alias',
    'Applicant ID',
    'Application ID',
    'SDFC Lead ID',
    'Branch Name',
    'Product Line',
    'Pennant Analyst Name',
    'Analyst Email ID',
    'Field 1',
    'Field 2',
    'Field 3',
    'Field 4',
    'Field 5',
    'Field 6',
    'Field 7',
    'Field 8',
    'Field 9',
    'Field 10',
    'Field 11',
    'Field 12',
    'Field 13',
    'Field 14',
    'Field 15',
    'Field 16',
    'Field 17',
    'Field 18',
    'Field 19',
    'Field 20',
  ],
  e: [
    'S.no',
    'Org Name',
    'D.O.E (yyyy-mm-dd)',
    'Phone No',
    'Email',
    'Country 1',
    'Country 2',
    'Country 3',
    'Country 4',
    'Headquarters',
    'Country of Jurisdiction',
    'Address 1',
    'Address 2',
    'Address 3',
    'Address 4',
    'City 1',
    'City 2',
    'City 3',
    'City 4',
    'State 1',
    'State 2',
    'State 3',
    'State 4',
    'ZIP Code 1',
    'ZIP Code 2',
    'ZIP Code 3',
    'ZIP Code 4',
    'CIN',
    'GST',
    'ISIN',
    'TIN/PAN',
    'Alias',
    'Applicant ID',
    'Application ID',
    'SDFC Lead ID',
    'Branch Name',
    'Product Line',
    'Pennant Analyst Name',
    'Analyst Email ID',
    'Field 1',
    'Field 2',
    'Field 3',
    'Field 4',
    'Field 5',
    'Field 6',
    'Field 7',
    'Field 8',
    'Field 9',
    'Field 10',
    'Field 11',
    'Field 12',
    'Field 13',
    'Field 14',
    'Field 15',
    'Field 16',
    'Field 17',
    'Field 18',
    'Field 19',
    'Field 20',
  ],
  v: [
    'S.no',
    'Vessel Name',
    'Mfd date (yyyy-mm-dd)',
    'Vessel Type',
    'Country 1',
    'Country 2',
    'Country 3',
    'Country 4',
    'Flag State',
    'Country of Jurisdiction',
    'Registered Owner',
    'Parent Company',
    'Address 1',
    'Address 2',
    'Address 3',
    'Address 4',
    'City 1',
    'City 2',
    'City 3',
    'City 4',
    'State 1',
    'State 2',
    'State 3',
    'State 4',
    'ZIP Code 1',
    'ZIP Code 2',
    'ZIP Code 3',
    'ZIP Code 4',
    'IMO',
    'MMSI',
    'Alias',
  ],
  a: [
    'S.no',
    'Aircraft Name',
    'Mfd Date (yyyy-mm-dd)',
    'Program',
    'Country 1',
    'Country 2',
    'Country 3',
    'Country 4',
    'Aircraft Model',
    'Country of Jurisdiction',
    'Operator',
    'Address 1',
    'Address 2',
    'Address 3',
    'Address 4',
    'City 1',
    'City 2',
    'City 3',
    'City 4',
    'State 1',
    'State 2',
    'State 3',
    'State 4',
    'ZIP Code 1',
    'ZIP Code 2',
    'ZIP Code 3',
    'ZIP Code 4',
    'Manufacture Serial no',
    'Construction Number',
    'Alias',
  ],
  b: [
    'S.no',
    'Name',
    'Alias',
    'DOB/DOM/DOE(yyyy-mm-dd)',
    'Nationality',
    'Gender',
    'Country 1',
    'Country 2',
    'Country 3',
    'Country 4',
    'Country of Jurisdiction',
    'Address 1',
    'Address 2',
    'Address 3',
    'Address 4',
    'City 1',
    'City 2',
    'City 3',
    'City 4',
    'State 1',
    'State 2',
    'State 3',
    'State 4',
    'ZIP Code 1',
    'ZIP Code 2',
    'ZIP Code 3',
    'ZIP Code 4',
    'TIN/PAN',
    'Passport Number',
    'Voter ID',
    'Driving License',
    'National ID',
    'Phone No',
    'Email',
    'Headquarters',
    'CIN',
    'GST',
    'ISIN',
    'SSN',
    'Vessel Type',
    'Flag State',
    'MMSI',
    'Registered Owner',
    'Tonnage',
    'IMO',
    'Parent Company',
    'Program',
    'Aircraft Operator/Owner',
    'Aircraft Model',
    'Manufacture Serial no',
    'Construction Number',
    'Applicant ID',
    'Application ID',
    'SDFC Lead ID',
    'Branch Name',
    'Product Line',
    'Pennant Analyst Name',
    'Analyst Email ID',
    'Field 1',
    'Field 2',
    'Field 3',
    'Field 4',
    'Field 5',
    'Field 6',
    'Field 7',
    'Field 8',
    'Field 9',
    'Field 10',
    'Field 11',
    'Field 12',
    'Field 13',
    'Field 14',
    'Field 15',
    'Field 16',
    'Field 17',
    'Field 18',
    'Field 19',
    'Field 20',
  ],
};
// ONGOING WITH RISK RATING PERMISSION
const BULK_FILE_RISK_LIST_TYPE_COLUMNS = {
  i: [
    'S.no',
    'Full Name',
    'Gender',
    'D.O.B (yyyy-mm-dd)',
    'Nationality',
    'SSN',
    'Country 1',
    'Country 2',
    'Country 3',
    'Country 4',
    'Country of Jurisdiction',
    'Address 1',
    'Address 2',
    'Address 3',
    'Address 4',
    'City 1',
    'City 2',
    'City 3',
    'City 4',
    'State 1',
    'State 2',
    'State 3',
    'State 4',
    'ZIP Code 1',
    'ZIP Code 2',
    'ZIP Code 3',
    'ZIP Code 4',
    'Passport Number',
    'Voter ID',
    'Driving License',
    'Phone No',
    'Email',
    'PAN',
    'National ID',
    'Alias',
    'Ongoing Monitoring End date (yyyy-mm-dd)',
    'Age',
    'Occupation',
    'Income',
    'Product Type',
    'Onboarding Duration',
    'Onboarding Type',
    'Missed Payment',
    'Applicant ID',
    'Application ID',
    'SDFC Lead ID',
    'Branch Name',
    'Product Line',
    'Pennant Analyst Name',
    'Analyst Email ID',
    'Field 1',
    'Field 2',
    'Field 3',
    'Field 4',
    'Field 5',
    'Field 6',
    'Field 7',
    'Field 8',
    'Field 9',
    'Field 10',
    'Field 11',
    'Field 12',
    'Field 13',
    'Field 14',
    'Field 15',
    'Field 16',
    'Field 17',
    'Field 18',
    'Field 19',
    'Field 20',
  ],
  e: [
    'S.no',
    'Org Name',
    'D.O.E (yyyy-mm-dd)',
    'Phone No',
    'Email',
    'Country 1',
    'Country 2',
    'Country 3',
    'Country 4',
    'Headquarters',
    'Country of Jurisdiction',
    'Address 1',
    'Address 2',
    'Address 3',
    'Address 4',
    'City 1',
    'City 2',
    'City 3',
    'City 4',
    'State 1',
    'State 2',
    'State 3',
    'State 4',
    'ZIP Code 1',
    'ZIP Code 2',
    'ZIP Code 3',
    'ZIP Code 4',
    'CIN',
    'GST',
    'ISIN',
    'TIN/PAN',
    'Alias',
    'Ongoing Monitoring End date (yyyy-mm-dd)',
    'Incorporation',
    'Industry',
    'Income',
    'Product Type',
    'Onboarding Duration',
    'Onboarding Type',
    'Missed Payment',
    'Applicant ID',
    'Application ID',
    'SDFC Lead ID',
    'Branch Name',
    'Product Line',
    'Pennant Analyst Name',
    'Analyst Email ID',
    'Field 1',
    'Field 2',
    'Field 3',
    'Field 4',
    'Field 5',
    'Field 6',
    'Field 7',
    'Field 8',
    'Field 9',
    'Field 10',
    'Field 11',
    'Field 12',
    'Field 13',
    'Field 14',
    'Field 15',
    'Field 16',
    'Field 17',
    'Field 18',
    'Field 19',
    'Field 20',
  ],
  v: [
    'S.no',
    'Vessel Name',
    'Mfd date (yyyy-mm-dd)',
    'Vessel Type',
    'Country 1',
    'Country 2',
    'Country 3',
    'Country 4',
    'Flag State',
    'Country of Jurisdiction',
    'Registered Owner',
    'Parent Company',
    'Address 1',
    'Address 2',
    'Address 3',
    'Address 4',
    'City 1',
    'City 2',
    'City 3',
    'City 4',
    'State 1',
    'State 2',
    'State 3',
    'State 4',
    'ZIP Code 1',
    'ZIP Code 2',
    'ZIP Code 3',
    'ZIP Code 4',
    'IMO',
    'MMSI',
    'Alias',
    'Ongoing Monitoring End date (yyyy-mm-dd)',
  ],
  a: [
    'S.no',
    'Aircraft Name',
    'Mfd Date (yyyy-mm-dd)',
    'Program',
    'Country 1',
    'Country 2',
    'Country 3',
    'Country 4',
    'Aircraft Model',
    'Country of Jurisdiction',
    'Operator',
    'Address 1',
    'Address 2',
    'Address 3',
    'Address 4',
    'City 1',
    'City 2',
    'City 3',
    'City 4',
    'State 1',
    'State 2',
    'State 3',
    'State 4',
    'ZIP Code 1',
    'ZIP Code 2',
    'ZIP Code 3',
    'ZIP Code 4',
    'Manufacture Serial no',
    'Construction Number',
    'Alias',
    'Ongoing Monitoring End date (yyyy-mm-dd)',
  ],
  b: [
    'S.no',
    'Name',
    'Alias',
    'DOB/DOM/DOE(yyyy-mm-dd)',
    'Nationality',
    'Gender',
    'Country 1',
    'Country 2',
    'Country 3',
    'Country 4',
    'Country of Jurisdiction',
    'Address 1',
    'Address 2',
    'Address 3',
    'Address 4',
    'City 1',
    'City 2',
    'City 3',
    'City 4',
    'State 1',
    'State 2',
    'State 3',
    'State 4',
    'ZIP Code 1',
    'ZIP Code 2',
    'ZIP Code 3',
    'ZIP Code 4',
    'TIN/PAN',
    'Passport Number',
    'Voter ID',
    'Driving License',
    'National ID',
    'Phone No',
    'Email',
    'Headquarters',
    'CIN',
    'GST',
    'ISIN',
    'SSN',
    'Vessel Type',
    'Flag State',
    'MMSI',
    'Registered Owner',
    'Tonnage',
    'IMO',
    'Parent Company',
    'Program',
    'Aircraft Operator/Owner',
    'Aircraft Model',
    'Manufacture Serial no',
    'Construction Number',
    'Ongoing Monitoring End date (yyyy-mm-dd)',
    'Applicant ID',
    'Application ID',
    'SDFC Lead ID',
    'Branch Name',
    'Product Line',
    'Pennant Analyst Name',
    'Analyst Email ID',
    'Field 1',
    'Field 2',
    'Field 3',
    'Field 4',
    'Field 5',
    'Field 6',
    'Field 7',
    'Field 8',
    'Field 9',
    'Field 10',
    'Field 11',
    'Field 12',
    'Field 13',
    'Field 14',
    'Field 15',
    'Field 16',
    'Field 17',
    'Field 18',
    'Field 19',
    'Field 20',
  ],
};
// INITITALL WITH RISK RATING
const BULK_INITIAL_FILE_RISK_LIST_TYPE_COLUMNS = {
  i: [
    'S.no',
    'Full Name',
    'Gender',
    'D.O.B (yyyy-mm-dd)',
    'Nationality',
    'SSN',
    'Country 1',
    'Country 2',
    'Country 3',
    'Country 4',
    'Country of Jurisdiction',
    'Address 1',
    'Address 2',
    'Address 3',
    'Address 4',
    'City 1',
    'City 2',
    'City 3',
    'City 4',
    'State 1',
    'State 2',
    'State 3',
    'State 4',
    'ZIP Code 1',
    'ZIP Code 2',
    'ZIP Code 3',
    'ZIP Code 4',
    'Passport Number',
    'Voter ID',
    'Driving License',
    'Phone No',
    'Email',
    'PAN',
    'National ID',
    'Alias',
    'Age',
    'Occupation',
    'Income',
    'Product Type',
    'Onboarding Duration',
    'Onboarding Type',
    'Missed Payment',
    'Applicant ID',
    'Application ID',
    'SDFC Lead ID',
    'Branch Name',
    'Product Line',
    'Pennant Analyst Name',
    'Analyst Email ID',
    'Field 1',
    'Field 2',
    'Field 3',
    'Field 4',
    'Field 5',
    'Field 6',
    'Field 7',
    'Field 8',
    'Field 9',
    'Field 10',
    'Field 11',
    'Field 12',
    'Field 13',
    'Field 14',
    'Field 15',
    'Field 16',
    'Field 17',
    'Field 18',
    'Field 19',
    'Field 20',
  ],
  e: [
    'S.no',
    'Org Name',
    'D.O.E (yyyy-mm-dd)',
    'Phone No',
    'Email',
    'Country 1',
    'Country 2',
    'Country 3',
    'Country 4',
    'Headquarters',
    'Country of Jurisdiction',
    'Address 1',
    'Address 2',
    'Address 3',
    'Address 4',
    'City 1',
    'City 2',
    'City 3',
    'City 4',
    'State 1',
    'State 2',
    'State 3',
    'State 4',
    'ZIP Code 1',
    'ZIP Code 2',
    'ZIP Code 3',
    'ZIP Code 4',
    'CIN',
    'GST',
    'ISIN',
    'TIN/PAN',
    'Alias',
    'Incorporation',
    'Industry',
    'Income',
    'Product Type',
    'Onboarding Duration',
    'Onboarding Type',
    'Missed Payment',
    'Applicant ID',
    'Application ID',
    'SDFC Lead ID',
    'Branch Name',
    'Product Line',
    'Pennant Analyst Name',
    'Analyst Email ID',
    'Field 1',
    'Field 2',
    'Field 3',
    'Field 4',
    'Field 5',
    'Field 6',
    'Field 7',
    'Field 8',
    'Field 9',
    'Field 10',
    'Field 11',
    'Field 12',
    'Field 13',
    'Field 14',
    'Field 15',
    'Field 16',
    'Field 17',
    'Field 18',
    'Field 19',
    'Field 20',
  ],
  v: [
    'S.no',
    'Vessel Name',
    'Mfd date (yyyy-mm-dd)',
    'Vessel Type',
    'Country 1',
    'Country 2',
    'Country 3',
    'Country 4',
    'Flag State',
    'Country of Jurisdiction',
    'Registered Owner',
    'Parent Company',
    'Address 1',
    'Address 2',
    'Address 3',
    'Address 4',
    'City 1',
    'City 2',
    'City 3',
    'City 4',
    'State 1',
    'State 2',
    'State 3',
    'State 4',
    'ZIP Code 1',
    'ZIP Code 2',
    'ZIP Code 3',
    'ZIP Code 4',
    'IMO',
    'MMSI',
    'Alias',
  ],
  a: [
    'S.no',
    'Aircraft Name',
    'Mfd Date (yyyy-mm-dd)',
    'Program',
    'Country 1',
    'Country 2',
    'Country 3',
    'Country 4',
    'Aircraft Model',
    'Country of Jurisdiction',
    'Operator',
    'Address 1',
    'Address 2',
    'Address 3',
    'Address 4',
    'City 1',
    'City 2',
    'City 3',
    'City 4',
    'State 1',
    'State 2',
    'State 3',
    'State 4',
    'ZIP Code 1',
    'ZIP Code 2',
    'ZIP Code 3',
    'ZIP Code 4',
    'Manufacture Serial no',
    'Construction Number',
    'Alias',
  ],
  b: [
    'S.no',
    'Name',
    'Alias',
    'DOB/DOM/DOE(yyyy-mm-dd)',
    'Nationality',
    'Gender',
    'Country 1',
    'Country 2',
    'Country 3',
    'Country 4',
    'Country of Jurisdiction',
    'Address 1',
    'Address 2',
    'Address 3',
    'Address 4',
    'City 1',
    'City 2',
    'City 3',
    'City 4',
    'State 1',
    'State 2',
    'State 3',
    'State 4',
    'ZIP Code 1',
    'ZIP Code 2',
    'ZIP Code 3',
    'ZIP Code 4',
    'TIN/PAN',
    'Passport Number',
    'Voter ID',
    'Driving License',
    'National ID',
    'Phone No',
    'Email',
    'Headquarters',
    'CIN',
    'GST',
    'ISIN',
    'SSN',
    'Vessel Type',
    'Flag State',
    'MMSI',
    'Registered Owner',
    'Tonnage',
    'IMO',
    'Parent Company',
    'Program',
    'Aircraft Operator/Owner',
    'Aircraft Model',
    'Manufacture Serial no',
    'Construction Number',
    'Applicant ID',
    'Application ID',
    'SDFC Lead ID',
    'Branch Name',
    'Product Line',
    'Pennant Analyst Name',
    'Analyst Email ID',
    'Field 1',
    'Field 2',
    'Field 3',
    'Field 4',
    'Field 5',
    'Field 6',
    'Field 7',
    'Field 8',
    'Field 9',
    'Field 10',
    'Field 11',
    'Field 12',
    'Field 13',
    'Field 14',
    'Field 15',
    'Field 16',
    'Field 17',
    'Field 18',
    'Field 19',
    'Field 20',
  ],
};
const BULK_INITIAL_FILE_TRANSACTION_LIST_TYPE_COLUMNS = {
  i: [
    'S.no',
    'Transaction ID',
    'Transaction Type',
    'Channel Type',
    'Transaction Product Type',
    'Amount',
    'Currency',
    'Transaction Date (yyyy-mm-dd)',
    'Remarks/Comments',
    'Bank Identifier Code',
    'Intermediary Bank Name',
    'Postal Address',
    'Financial Institution ID',
    'Type',
    'Full Name',
    'Alias',
    'Gender',
    'D.O.B (yyyy-mm-dd)',
    'Nationality',
    'Country 1',
    'Country 2',
    'Country 3',
    'Country 4',
    'Country of Jurisdiction',
    'Address 1',
    'Address 2',
    'Address 3',
    'Address 4',
    'City 1',
    'City 2',
    'City 3',
    'City 4',
    'State 1',
    'State 2',
    'State 3',
    'State 4',
    'ZIP Code 1',
    'ZIP Code 2',
    'ZIP Code 3',
    'ZIP Code 4',
    'Passport Number',
    'Voter ID',
    'Driving License',
    'Phone No',
    'Email',
    'PAN',
    'National ID',
    'SSN',
    'KYCID',
    'Account Number',
    'IFSC Code/Bank ID',
    'Bank Name',
    'Applicant ID',
    'Application ID',
    'SDFC Lead ID',
    'Branch Name',
    'Product Line',
    'Pennant Analyst Name',
    'Analyst Email ID',
    'Field 1',
    'Field 2',
    'Field 3',
    'Field 4',
    'Field 5',
    'Field 6',
    'Field 7',
    'Field 8',
    'Field 9',
    'Field 10',
    'Field 11',
    'Field 12',
    'Field 13',
    'Field 14',
    'Field 15',
    'Field 16',
    'Field 17',
    'Field 18',
    'Field 19',
    'Field 20',
    'Transaction Field 1',
    'Transaction Field 2',
    'Transaction Field 3',
    'Skip Screening',
  ],
  e: [
    'S.no',
    'Transaction ID',
    'Transaction Type',
    'Channel Type',
    'Transaction Product Type',
    'Amount',
    'Currency',
    'Transaction Date (yyyy-mm-dd)',
    'Remarks/Comments',
    'Bank Identifier Code',
    'Intermediary Bank Name',
    'Postal Address',
    'Financial Institution ID',
    'Type',
    'Org Name',
    'Alias',
    'Phone No',
    'Email',
    'Country 1',
    'Country 2',
    'Country 3',
    'Country 4',
    'D.O.E (yyyy-mm-dd)',
    'Headquarters',
    'Country of Jurisdiction',
    'Address 1',
    'Address 2',
    'Address 3',
    'Address 4',
    'City 1',
    'City 2',
    'City 3',
    'City 4',
    'State 1',
    'State 2',
    'State 3',
    'State 4',
    'ZIP Code 1',
    'ZIP Code 2',
    'ZIP Code 3',
    'ZIP Code 4',
    'KYCID',
    'CIN',
    'GST',
    'ISIN',
    'TIN/PAN',
    'Account Number',
    'IFSC Code/Bank ID',
    'Bank Name',
    'Applicant ID',
    'Application ID',
    'SDFC Lead ID',
    'Branch Name',
    'Product Line',
    'Pennant Analyst Name',
    'Analyst Email ID',
    'Field 1',
    'Field 2',
    'Field 3',
    'Field 4',
    'Field 5',
    'Field 6',
    'Field 7',
    'Field 8',
    'Field 9',
    'Field 10',
    'Field 11',
    'Field 12',
    'Field 13',
    'Field 14',
    'Field 15',
    'Field 16',
    'Field 17',
    'Field 18',
    'Field 19',
    'Field 20',
    'Transaction Field 1',
    'Transaction Field 2',
    'Transaction Field 3',
    'Skip Screening',
  ],
  b: [
    'S.no',
    'Transaction ID',
    'Transaction Type',
    'Channel Type',
    'Transaction Product Type',
    'Amount',
    'Currency',
    'Transaction Date (yyyy-mm-dd)',
    'Remarks/Comments',
    'Bank Identifier Code',
    'Intermediary Bank Name',
    'Postal Address',
    'Financial Institution ID',
    'Type',
    'Name',
    'Alias',
    'Gender',
    'DOB/DOM/DOE(yyyy-mm-dd)',
    'Nationality',
    'Country 1',
    'Country 2',
    'Country 3',
    'Country 4',
    'Headquarters',
    'Country of Jurisdiction',
    'Address 1',
    'Address 2',
    'Address 3',
    'Address 4',
    'City 1',
    'City 2',
    'City 3',
    'City 4',
    'State 1',
    'State 2',
    'State 3',
    'State 4',
    'ZIP Code 1',
    'ZIP Code 2',
    'ZIP Code 3',
    'ZIP Code 4',
    'Passport Number',
    'Voter ID',
    'Driving License',
    'Phone No',
    'Email',
    'National ID',
    'KYCID',
    'CIN',
    'SSN',
    'GST',
    'ISIN',
    'TIN/PAN',
    'Vessel Type',
    'Flag State',
    'Program',
    'Aircraft Operator/Owner',
    'Manufacture Serial no',
    'MMSI',
    'Registered Owner',
    'Tonnage',
    'Aircraft Model',
    'IMO',
    'Construction Number',
    'Parent Company',
    'Account Number',
    'IFSC Code/Bank ID',
    'Bank Name',
    'Applicant ID',
    'Application ID',
    'SDFC Lead ID',
    'Branch Name',
    'Product Line',
    'Pennant Analyst Name',
    'Analyst Email ID',
    'Field 1',
    'Field 2',
    'Field 3',
    'Field 4',
    'Field 5',
    'Field 6',
    'Field 7',
    'Field 8',
    'Field 9',
    'Field 10',
    'Field 11',
    'Field 12',
    'Field 13',
    'Field 14',
    'Field 15',
    'Field 16',
    'Field 17',
    'Field 18',
    'Field 19',
    'Field 20',
    'Transaction Field 1',
    'Transaction Field 2',
    'Transaction Field 3',
    'Skip Screening',
  ],
};

const BULK_INITIAL_FILE_TRANSACTION_RISK_LIST_TYPE_COLUMNS = {
  i: [
    'S.no',
    'Transaction ID',
    'Transaction Type',
    'Channel Type',
    'Transaction Product Type',
    'Amount',
    'Currency',
    'Transaction Date (yyyy-mm-dd)',
    'Remarks/Comments',
    'Bank Identifier Code',
    'Intermediary Bank Name',
    'Postal Address',
    'Financial Institution ID',
    'Type',
    'Full Name',
    'Alias',
    'Gender',
    'D.O.B (yyyy-mm-dd)',
    'Nationality',
    'Country 1',
    'Country 2',
    'Country 3',
    'Country 4',
    'Country of Jurisdiction',
    'Address 1',
    'Address 2',
    'Address 3',
    'Address 4',
    'City 1',
    'City 2',
    'City 3',
    'City 4',
    'State 1',
    'State 2',
    'State 3',
    'State 4',
    'ZIP Code 1',
    'ZIP Code 2',
    'ZIP Code 3',
    'ZIP Code 4',
    'Passport Number',
    'Voter ID',
    'Driving License',
    'Phone No',
    'Email',
    'PAN',
    'National ID',
    'SSN',
    'KYCID',
    'Account Number',
    'IFSC Code/Bank ID',
    'Bank Name',
    'Age',
    'Occupation',
    'Income',
    'Onboarding Duration',
    'Onboarding Type',
    'Missed Payment',
    'Product Type',
    'Applicant ID',
    'Application ID',
    'SDFC Lead ID',
    'Branch Name',
    'Product Line',
    'Pennant Analyst Name',
    'Analyst Email ID',
    'Field 1',
    'Field 2',
    'Field 3',
    'Field 4',
    'Field 5',
    'Field 6',
    'Field 7',
    'Field 8',
    'Field 9',
    'Field 10',
    'Field 11',
    'Field 12',
    'Field 13',
    'Field 14',
    'Field 15',
    'Field 16',
    'Field 17',
    'Field 18',
    'Field 19',
    'Field 20',
    'Transaction Field 1',
    'Transaction Field 2',
    'Transaction Field 3',
    'Skip Screening',
  ],
  e: [
    'S.no',
    'Transaction ID',
    'Transaction Type',
    'Channel Type',
    'Transaction Product Type',
    'Amount',
    'Currency',
    'Transaction Date (yyyy-mm-dd)',
    'Remarks/Comments',
    'Bank Identifier Code',
    'Intermediary Bank Name',
    'Postal Address',
    'Financial Institution ID',
    'Type',
    'Org Name',
    'Alias',
    'Phone No',
    'Email',
    'Country 1',
    'Country 2',
    'Country 3',
    'Country 4',
    'D.O.E (yyyy-mm-dd)',
    'Headquarters',
    'Country of Jurisdiction',
    'Address 1',
    'Address 2',
    'Address 3',
    'Address 4',
    'City 1',
    'City 2',
    'City 3',
    'City 4',
    'State 1',
    'State 2',
    'State 3',
    'State 4',
    'ZIP Code 1',
    'ZIP Code 2',
    'ZIP Code 3',
    'ZIP Code 4',
    'KYCID',
    'CIN',
    'GST',
    'ISIN',
    'TIN/PAN',
    'Account Number',
    'IFSC Code/Bank ID',
    'Bank Name',
    'Incorporation',
    'Industry',
    'Income',
    'Onboarding Duration',
    'Onboarding Type',
    'Missed Payment',
    'Product Type',
    'Applicant ID',
    'Application ID',
    'SDFC Lead ID',
    'Branch Name',
    'Product Line',
    'Pennant Analyst Name',
    'Analyst Email ID',
    'Field 1',
    'Field 2',
    'Field 3',
    'Field 4',
    'Field 5',
    'Field 6',
    'Field 7',
    'Field 8',
    'Field 9',
    'Field 10',
    'Field 11',
    'Field 12',
    'Field 13',
    'Field 14',
    'Field 15',
    'Field 16',
    'Field 17',
    'Field 18',
    'Field 19',
    'Field 20',
    'Transaction Field 1',
    'Transaction Field 2',
    'Transaction Field 3',
    'Skip Screening',
  ],
  b: [
    'S.no',
    'Transaction ID',
    'Transaction Type',
    'Channel Type',
    'Transaction Product Type',
    'Amount',
    'Currency',
    'Transaction Date (yyyy-mm-dd)',
    'Remarks/Comments',
    'Bank Identifier Code',
    'Intermediary Bank Name',
    'Postal Address',
    'Financial Institution ID',
    'Type',
    'Name',
    'Alias',
    'Gender',
    'DOB/DOM/DOE(yyyy-mm-dd)',
    'Nationality',
    'Country 1',
    'Country 2',
    'Country 3',
    'Country 4',
    'Headquarters',
    'Country of Jurisdiction',
    'Address 1',
    'Address 2',
    'Address 3',
    'Address 4',
    'City 1',
    'City 2',
    'City 3',
    'City 4',
    'State 1',
    'State 2',
    'State 3',
    'State 4',
    'ZIP Code 1',
    'ZIP Code 2',
    'ZIP Code 3',
    'ZIP Code 4',
    'Passport Number',
    'Voter ID',
    'Driving License',
    'Phone No',
    'Email',
    'National ID',
    'KYCID',
    'CIN',
    'SSN',
    'GST',
    'ISIN',
    'TIN/PAN',
    'Vessel Type',
    'Flag State',
    'Program',
    'Aircraft Operator/Owner',
    'Manufacture Serial no',
    'MMSI',
    'Registered Owner',
    'Tonnage',
    'Aircraft Model',
    'IMO',
    'Construction Number',
    'Parent Company',
    'Account Number',
    'IFSC Code/Bank ID',
    'Bank Name',
    'Applicant ID',
    'Application ID',
    'SDFC Lead ID',
    'Branch Name',
    'Product Line',
    'Pennant Analyst Name',
    'Analyst Email ID',
    'Field 1',
    'Field 2',
    'Field 3',
    'Field 4',
    'Field 5',
    'Field 6',
    'Field 7',
    'Field 8',
    'Field 9',
    'Field 10',
    'Field 11',
    'Field 12',
    'Field 13',
    'Field 14',
    'Field 15',
    'Field 16',
    'Field 17',
    'Field 18',
    'Field 19',
    'Field 20',
    'Transaction Field 1',
    'Transaction Field 2',
    'Transaction Field 3',
    'Skip Screening',
  ],
};

const BULK_ONGOING_FILE_TRANSACTION_LIST_TYPE_COLUMNS = {
  i: [
    'S.no',
    'Transaction ID',
    'Transaction Type',
    'Channel Type',
    'Transaction Product Type',
    'Amount',
    'Currency',
    'Transaction Date (yyyy-mm-dd)',
    'Remarks/Comments',
    'Bank Identifier Code',
    'Intermediary Bank Name',
    'Postal Address',
    'Financial Institution ID',
    'Type',
    'Full Name',
    'Alias',
    'Gender',
    'D.O.B (yyyy-mm-dd)',
    'Nationality',
    'Country 1',
    'Country 2',
    'Country 3',
    'Country 4',
    'Country of Jurisdiction',
    'Address 1',
    'Address 2',
    'Address 3',
    'Address 4',
    'City 1',
    'City 2',
    'City 3',
    'City 4',
    'State 1',
    'State 2',
    'State 3',
    'State 4',
    'ZIP Code 1',
    'ZIP Code 2',
    'ZIP Code 3',
    'ZIP Code 4',
    'Passport Number',
    'Voter ID',
    'Driving License',
    'Phone No',
    'Email',
    'PAN',
    'National ID',
    'SSN',
    'KYCID',
    'Account Number',
    'IFSC Code/Bank ID',
    'Bank Name',
    'Ongoing Monitoring End date (yyyy-mm-dd)',
    'Applicant ID',
    'Application ID',
    'SDFC Lead ID',
    'Branch Name',
    'Product Line',
    'Pennant Analyst Name',
    'Analyst Email ID',
    'Field 1',
    'Field 2',
    'Field 3',
    'Field 4',
    'Field 5',
    'Field 6',
    'Field 7',
    'Field 8',
    'Field 9',
    'Field 10',
    'Field 11',
    'Field 12',
    'Field 13',
    'Field 14',
    'Field 15',
    'Field 16',
    'Field 17',
    'Field 18',
    'Field 19',
    'Field 20',
    'Transaction Field 1',
    'Transaction Field 2',
    'Transaction Field 3',
    'Skip Screening',
  ],
  e: [
    'S.no',
    'Transaction ID',
    'Transaction Type',
    'Channel Type',
    'Transaction Product Type',
    'Amount',
    'Currency',
    'Transaction Date (yyyy-mm-dd)',
    'Remarks/Comments',
    'Bank Identifier Code',
    'Intermediary Bank Name',
    'Postal Address',
    'Financial Institution ID',
    'Type',
    'Org Name',
    'Alias',
    'Phone No',
    'Email',
    'Country 1',
    'Country 2',
    'Country 3',
    'Country 4',
    'D.O.E (yyyy-mm-dd)',
    'Headquarters',
    'Country of Jurisdiction',
    'Address 1',
    'Address 2',
    'Address 3',
    'Address 4',
    'City 1',
    'City 2',
    'City 3',
    'City 4',
    'State 1',
    'State 2',
    'State 3',
    'State 4',
    'ZIP Code 1',
    'ZIP Code 2',
    'ZIP Code 3',
    'ZIP Code 4',
    'KYCID',
    'CIN',
    'GST',
    'ISIN',
    'TIN/PAN',
    'Account Number',
    'IFSC Code/Bank ID',
    'Bank Name',
    'Applicant ID',
    'Application ID',
    'SDFC Lead ID',
    'Branch Name',
    'Product Line',
    'Pennant Analyst Name',
    'Analyst Email ID',
    'Field 1',
    'Field 2',
    'Field 3',
    'Field 4',
    'Field 5',
    'Field 6',
    'Field 7',
    'Field 8',
    'Field 9',
    'Field 10',
    'Field 11',
    'Field 12',
    'Field 13',
    'Field 14',
    'Field 15',
    'Field 16',
    'Field 17',
    'Field 18',
    'Field 19',
    'Field 20',
    'Ongoing Monitoring End date (yyyy-mm-dd)',
    'Transaction Field 1',
    'Transaction Field 2',
    'Transaction Field 3',
    'Skip Screening',
  ],
  b: [
    'S.no',
    'Transaction ID',
    'Transaction Type',
    'Channel Type',
    'Transaction Product Type',
    'Amount',
    'Currency',
    'Transaction Date (yyyy-mm-dd)',
    'Remarks/Comments',
    'Bank Identifier Code',
    'Intermediary Bank Name',
    'Postal Address',
    'Financial Institution ID',
    'Type',
    'Name',
    'Alias',
    'Gender',
    'DOB/DOM/DOE(yyyy-mm-dd)',
    'Nationality',
    'Country 1',
    'Country 2',
    'Country 3',
    'Country 4',
    'Headquarters',
    'Country of Jurisdiction',
    'Address 1',
    'Address 2',
    'Address 3',
    'Address 4',
    'City 1',
    'City 2',
    'City 3',
    'City 4',
    'State 1',
    'State 2',
    'State 3',
    'State 4',
    'ZIP Code 1',
    'ZIP Code 2',
    'ZIP Code 3',
    'ZIP Code 4',
    'Passport Number',
    'Voter ID',
    'Driving License',
    'Phone No',
    'Email',
    'National ID',
    'KYCID',
    'CIN',
    'SSN',
    'GST',
    'ISIN',
    'TIN/PAN',
    'Ongoing Monitoring End date (yyyy-mm-dd)',
    'Vessel Type',
    'Flag State',
    'Program',
    'Aircraft Operator/Owner',
    'Manufacture Serial no',
    'MMSI',
    'Registered Owner',
    'Tonnage',
    'Aircraft Model',
    'IMO',
    'Construction Number',
    'Parent Company',
    'Account Number',
    'IFSC Code/Bank ID',
    'Bank Name',
    'Applicant ID',
    'Application ID',
    'SDFC Lead ID',
    'Branch Name',
    'Product Line',
    'Pennant Analyst Name',
    'Analyst Email ID',
    'Field 1',
    'Field 2',
    'Field 3',
    'Field 4',
    'Field 5',
    'Field 6',
    'Field 7',
    'Field 8',
    'Field 9',
    'Field 10',
    'Field 11',
    'Field 12',
    'Field 13',
    'Field 14',
    'Field 15',
    'Field 16',
    'Field 17',
    'Field 18',
    'Field 19',
    'Field 20',
    'Transaction Field 1',
    'Transaction Field 2',
    'Transaction Field 3',
    'Skip Screening',
  ],
};

const BULK_ONGOING_FILE_TRANSACTION_RISK_LIST_TYPE_COLUMNS = {
  i: [
    'S.no',
    'Transaction ID',
    'Transaction Type',
    'Channel Type',
    'Transaction Product Type',
    'Amount',
    'Currency',
    'Transaction Date (yyyy-mm-dd)',
    'Remarks/Comments',
    'Bank Identifier Code',
    'Intermediary Bank Name',
    'Postal Address',
    'Financial Institution ID',
    'Type',
    'Full Name',
    'Alias',
    'Gender',
    'D.O.B (yyyy-mm-dd)',
    'Nationality',
    'Country 1',
    'Country 2',
    'Country 3',
    'Country 4',
    'Country of Jurisdiction',
    'Address 1',
    'Address 2',
    'Address 3',
    'Address 4',
    'City 1',
    'City 2',
    'City 3',
    'City 4',
    'State 1',
    'State 2',
    'State 3',
    'State 4',
    'ZIP Code 1',
    'ZIP Code 2',
    'ZIP Code 3',
    'ZIP Code 4',
    'Passport Number',
    'Voter ID',
    'Driving License',
    'Phone No',
    'Email',
    'PAN',
    'National ID',
    'SSN',
    'KYCID',
    'Account Number',
    'IFSC Code/Bank ID',
    'Bank Name',
    'Ongoing Monitoring End date (yyyy-mm-dd)',
    'Age',
    'Occupation',
    'Income',
    'Onboarding Duration',
    'Onboarding Type',
    'Missed Payment',
    'Product Type',
    'Applicant ID',
    'Application ID',
    'SDFC Lead ID',
    'Branch Name',
    'Product Line',
    'Pennant Analyst Name',
    'Analyst Email ID',
    'Field 1',
    'Field 2',
    'Field 3',
    'Field 4',
    'Field 5',
    'Field 6',
    'Field 7',
    'Field 8',
    'Field 9',
    'Field 10',
    'Field 11',
    'Field 12',
    'Field 13',
    'Field 14',
    'Field 15',
    'Field 16',
    'Field 17',
    'Field 18',
    'Field 19',
    'Field 20',
    'Transaction Field 1',
    'Transaction Field 2',
    'Transaction Field 3',
    'Skip Screening',
  ],
  e: [
    'S.no',
    'Transaction ID',
    'Transaction Type',
    'Channel Type',
    'Transaction Product Type',
    'Amount',
    'Currency',
    'Transaction Date (yyyy-mm-dd)',
    'Remarks/Comments',
    'Bank Identifier Code',
    'Intermediary Bank Name',
    'Postal Address',
    'Financial Institution ID',
    'Type',
    'Org Name',
    'Alias',
    'Phone No',
    'Email',
    'Country 1',
    'Country 2',
    'Country 3',
    'Country 4',
    'D.O.E (yyyy-mm-dd)',
    'Headquarters',
    'Country of Jurisdiction',
    'Address 1',
    'Address 2',
    'Address 3',
    'Address 4',
    'City 1',
    'City 2',
    'City 3',
    'City 4',
    'State 1',
    'State 2',
    'State 3',
    'State 4',
    'ZIP Code 1',
    'ZIP Code 2',
    'ZIP Code 3',
    'ZIP Code 4',
    'KYCID',
    'CIN',
    'GST',
    'ISIN',
    'TIN/PAN',
    'Account Number',
    'IFSC Code/Bank ID',
    'Bank Name',
    'Ongoing Monitoring End date (yyyy-mm-dd)',
    'Incorporation',
    'Industry',
    'Income',
    'Onboarding Duration',
    'Onboarding Type',
    'Missed Payment',
    'Product Type',
    'Applicant ID',
    'Application ID',
    'SDFC Lead ID',
    'Branch Name',
    'Product Line',
    'Pennant Analyst Name',
    'Analyst Email ID',
    'Field 1',
    'Field 2',
    'Field 3',
    'Field 4',
    'Field 5',
    'Field 6',
    'Field 7',
    'Field 8',
    'Field 9',
    'Field 10',
    'Field 11',
    'Field 12',
    'Field 13',
    'Field 14',
    'Field 15',
    'Field 16',
    'Field 17',
    'Field 18',
    'Field 19',
    'Field 20',
    'Transaction Field 1',
    'Transaction Field 2',
    'Transaction Field 3',
    'Skip Screening',
  ],
  b: [
    'S.no',
    'Transaction ID',
    'Transaction Type',
    'Channel Type',
    'Transaction Product Type',
    'Amount',
    'Currency',
    'Transaction Date (yyyy-mm-dd)',
    'Remarks/Comments',
    'Bank Identifier Code',
    'Intermediary Bank Name',
    'Postal Address',
    'Financial Institution ID',
    'Type',
    'Name',
    'Alias',
    'Gender',
    'DOB/DOM/DOE(yyyy-mm-dd)',
    'Nationality',
    'Country 1',
    'Country 2',
    'Country 3',
    'Country 4',
    'Headquarters',
    'Country of Jurisdiction',
    'Address 1',
    'Address 2',
    'Address 3',
    'Address 4',
    'City 1',
    'City 2',
    'City 3',
    'City 4',
    'State 1',
    'State 2',
    'State 3',
    'State 4',
    'ZIP Code 1',
    'ZIP Code 2',
    'ZIP Code 3',
    'ZIP Code 4',
    'Passport Number',
    'Voter ID',
    'Driving License',
    'Phone No',
    'Email',
    'National ID',
    'KYCID',
    'CIN',
    'SSN',
    'GST',
    'ISIN',
    'TIN/PAN',
    'Ongoing Monitoring End date (yyyy-mm-dd)',
    'Vessel Type',
    'Flag State',
    'Program',
    'Aircraft Operator/Owner',
    'Manufacture Serial no',
    'MMSI',
    'Registered Owner',
    'Tonnage',
    'Aircraft Model',
    'IMO',
    'Construction Number',
    'Parent Company',
    'Account Number',
    'IFSC Code/Bank ID',
    'Bank Name',
    'Applicant ID',
    'Application ID',
    'SDFC Lead ID',
    'Branch Name',
    'Product Line',
    'Pennant Analyst Name',
    'Analyst Email ID',
    'Field 1',
    'Field 2',
    'Field 3',
    'Field 4',
    'Field 5',
    'Field 6',
    'Field 7',
    'Field 8',
    'Field 9',
    'Field 10',
    'Field 11',
    'Field 12',
    'Field 13',
    'Field 14',
    'Field 15',
    'Field 16',
    'Field 17',
    'Field 18',
    'Field 19',
    'Field 20',
    'Transaction Field 1',
    'Transaction Field 2',
    'Transaction Field 3',
    'Skip Screening',
  ],
};
const PRIVATE_LIST_FILE_TYPE_COLUMNS = {
  individual: [
    'Name',
    'Alias_1',
    'Alias_2',
    'Alias_3',
    'Gender',
    'Nationality',
    'Date_Of_Birth(YYYY/MM/DD)',
    'Country_1',
    'City_1',
    'State_1',
    'Full_Address_1',
    'Zipcode',
    'Country_2',
    'City_2',
    'State_2',
    'Full_Address_2',
    'Zipcode_2',
    'National_id',
    'Voter_id',
    'Driving_License',
    'Country_of_jurisdiction',
    'Passport',
    'PAN',
    'TIN',
    'Phone No',
    'Email ID',
    'Digital Wallet',
    'Website',
    'Sanction_List_Source',
    'Sanction_List_Authority',
    'Sanction_list_Host_Country',
    'Sanction_List_URL',
    'Sanction_List_Type',
    'Sanction_List_Description',
  ],
  entity: [
    'Name',
    'Alias_1',
    'Alias_2',
    'Alias_3',
    'Date_Of_Establishment(YYYY/MM/DD)',
    'Country_of_jurisdiction',
    'Headquarters',
    'Email ID',
    'President',
    'Country_1',
    'City_1',
    'State_1',
    'Full_Address_1',
    'Zipcode',
    'Country_2',
    'City_2',
    'State_2',
    'Full_Address_2',
    'Zipcode_2',
    'CIN',
    'ISIN',
    'PAN',
    'GST',
    'Sanction_List_Source',
    'Sanction_List_Authority',
    'Sanction_list_Host_Country',
    'Sanction_List_URL',
    'Sanction_List_Type',
    'Sanction_List_Description',
  ],
  vessel: [
    'Name',
    'Alias_1',
    'Alias_2',
    'Alias_3',
    'Date_of_manufacturing(YYYY/MM/DD)',
    'Country_1',
    'Country_2',
    'Country_of_jurisdiction',
    'Address',
    'Zipcode',
    'IMO',
    'MMSI',
    'Vessel_Type',
    'Ship_Owner',
    'Registered_Owner',
    'Parent_Company',
    'Operational_Company',
    'Call_Sign',
    'Tonnage',
    'Gross_Registered_tonnage',
    'Flag_State',
    'Sanction_List_Source',
    'Sanction_List_Authority',
    'Sanction_list_Host_Country',
    'Sanction_List_URL',
    'Sanction_List_Type',
    'Sanction_List_Description',
  ],
  aircraft: [
    'Name',
    'Alias_1',
    'Alias_2',
    'Alias_3',
    'Date_of_manufacturing(YYYY/MM/DD)',
    'Country_1',
    'Country_2',
    'Address',
    'Zipcode',
    'Country_of_jurisdiction',
    'Aircraft_owner',
    'Model',
    'Manufacture_Serial_Number',
    'Tail_Number',
    'Program_1',
    'Program_2',
    'Program_3',
    'Construction_No',
    'Sanction_List_Source',
    'Sanction_List_Authority',
    'Sanction_list_Host_Country',
    'Sanction_List_URL',
    'Sanction_List_Type',
    'Sanction_List_Description',
  ],
};

const ADD_TO_EXCLUSION_COLUMNS = [
  'Name',
  'Search ID',
  'Customer ID',
  'Search Type',
];

const DATE_COLUMN_NAMES = [
  'D.O.B (yyyy-mm-dd)',
  'Mfd date (yyyy-mm-dd)',
  'D.O.E (yyyy-mm-dd)',
  'Mfd Date (yyyy-mm-dd)',
  'Ongoing Monitoring End date (yyyy-mm-dd)',
  'DOB/DOM/DOE(yyyy-mm-dd)',
  'Transaction Date (yyyy-mm-dd)',
];
const DATE_INITIAL_COLUMN_NAMES = [
  'D.O.B (yyyy-mm-dd)',
  'Mfd date (yyyy-mm-dd)',
  'D.O.E (yyyy-mm-dd)',
  'Mfd Date (yyyy-mm-dd)',
  'DOB/DOM/DOE(yyyy-mm-dd)',
  'Transaction Date (yyyy-mm-dd)',
];

const AMS_NAME_COLUMNS = {
  name: ['Name'],
  keyword: ['Keyword', 'Country'],
};
const RISK_RATING_COLUMNS = {
  occupation: ['Occupation'],
  product: ['Product Type'],
  industry: ['Industry Type'],
};
const TRANSACTION_SCREENING_COLUMNS = {
  channel: ['Channel Type'],
  product: ['Product Type'],
  transaction: ['Transaction Type'],
};
const ONBOARDING_TYPE = [
  'Face-to-face Onboarding',
  'Virtual Onboarding',
  'Third Party Onboarding',
];
const TTR_COLUMNS = {
  insurance: [
    'Rentity ID',
    'Rentity Branch',
    'Submission Code',
    'Report Code',
    'Submission Date',
    'Currency Code',
    'Reporting Person Gender',
    'Reporting Person Title',
    'Reporting Person First Name',
    'Reporting Person Last Name',
    'Reporting Person Birthdate',
    'Reporting Person SSN',
    'Reporting Person ID Number',
    'Reporting Person Nationality1',
    'Reporting Person Contact Type',
    'Reporting Person Communication Type',
    'Reporting Person Country Prefix',
    'Reporting Person Phone Number',
    'Reporting Person Address Type',
    'Reporting Person Address',
    'Reporting Person Town',
    'Reporting Person City',
    'Reporting Person Zip',
    'Reporting Person Country Code',
    'Reporting Person State',
    'Reporting Person Occupation',
    'Reporting Person Email',
    'Location Address Type',
    'Location Address',
    'Location Town',
    'Location City',
    'Location Zip',
    'Location Country Code',
    'Location State',
    'Reason',
    'Transaction Number',
    'Transaction Location',
    'Transaction Description',
    'Date Transaction',
    'Teller',
    'Authorized',
    'Transmode Code',
    'Amount Local',
    'From Funds Code',
    'Conductor First Name',
    'Conductor Last Name',
    'From Account Institution Name ',
    'From Account Swift',
    'From Account Account',
    'From Country',
    'To Funds Code',
    'To Account Institution Name',
    'To Account Institution Code',
    'To Account Branch',
    'To Account Account',
    'To Account Currency Code',
    'To Account Account Name',
    'To Account Personal Account Type',
    'To Account Is Primary',
    'To Account Role',
    'To Account Person Gender',
    'To Account Person First Name',
    'To Account Person Middle Name',
    'To Account Person Last Name',
    'To Account Person Birthdate',
    'To Account Person Birth Place',
    'To Account Person SSN',
    'To Account Person Nationality1',
    'To Account Person Residence',
    'To Account Person Phone Contact Type',
    'To Account Person Phone Communication Type',
    'To Account Person Phone Number',
    'To Account Address Type',
    'To Account Person Address',
    'To Account Person Address Town',
    'To Account Person Address City',
    'To Account Person Address Zip',
    'To Account Person Address Country Code',
    'To Account Person Occupation',
    'To Account Person Identification Type',
    'To Account Person Identification Number',
    'To Account Person Identification Issued By',
    'To Account Person Identification Issue Country',
    'To Account Opened',
    'To Account Balance',
    'To Account Date Balance',
    'To Account Status Code',
    'To Account Comments',
    'To Country',
  ],
  capital_market: [
    'Rentity ID',
    'Rentity Branch',
    'Submission Code',
    'Report Code',
    'Reporting User Code',
    'Report Date',
    'Currency Code',
    'Location Address Type',
    'Location Address',
    'Location Town',
    'Location City',
    'Location Zip',
    'Location Country Code',
    'Transaction Number',
    'Transaction Location',
    'Transaction Description',
    'Date Transaction',
    'Transmode Code',
    'Amount Local',
    'From Funds Code',
    'From Account Institution Name',
    'From Account Swift',
    'From Account Institution Country',
    'From Account Non Bank Institution',
    'From Account Branch',
    'From Account Account',
    'From Account Currency Code',
    'From Account Account Name',
    'From Account Comments',
    'From Country',
    'To Funds Code',
    'To Funds Comment',
    'To Country',
    'To Account Institution Name',
    'To Account Swift',
    'To Account Institution Country',
    'To Account Branch',
    'To Account Account',
    'To Account Currency Code',
    'To Account Account Name',
    'Related Person is Primary',
    'Related Person Role',
    'Related Person Gender',
    'Related Person First Name',
    'Related Person Middle Name',
    'Related Person Last Name',
    'Related Person Birthdate',
    'Related Person Birth Place',
    'Related Person Birth Country',
    'Related Person Mother Name',
    'Related Person Father Name',
    'Related Person Grandfather Name',
    'Related Person Spouse',
    'Related Person Alias',
    'Related Person SSN',
    'Related Person Nationality1',
    'Related Person Nationality2',
    'Related Person Nationality3',
    'Related Person Residence',
    'Related Person Occupation',
    'Related Person Email',
    'Related Person Tax Number',
    'Related Person Citizenship Number',
    'Related Person Tax Reg Number',
    'Related Person Source Of Wealth',
    'Related Person Contact Type',
    'Related Person Communication Type',
    'Related Person Phone Number',
    'Related Person Address Type',
    'Related Person Address',
    'Related Person Town',
    'Related Person City',
    'Related Person Zip',
    'Related Person State',
    'Related Person Country Code',
    'Related Person Identification Type',
    'Related Person Identification Number',
    'Related Person Identification Issue Date',
    'Related Person Identification Issued By',
    'Related Person Identification Issue Country',
    'Comments',
  ],
  right_share: [
    'Transaction Number',
    'Transaction Location',
    'Transaction Description 1',
    'Transaction Description 2',
    'Date Transaction',
    'Amount Local',
    'From Funds Type',
    'From Funds Comment',
    'From Account Institution Name',
    'From Account Swift',
    'From Account Institution Country',
    'From Account Branch',
    'From Account Number',
    'From Account Currency Code',
    'From Applicant Name',
    'From Account iban',
    'From Account Type',
    'From Country',
    'To Funds Code',
    'To Funds Comment',
    'To Account Institution Name',
    'To Account Swift',
    'To Account Institution Country',
    'To Account Branch',
    'To Account DMAT Account No./Shareholder No.',
    'To Account Currency Code',
    'To Account Applicant Name',
    'To Account iban',
    'To Account Type',
    'To Country',
    'Comments',
  ],
};
const AUDIT_TRAIL_PARAMETERS = {
  sectionData: [
    {
      label: 'Sanction Configuration',
      value: 'SanctionConfiguration',
      permission: 'sanctions-configuration',
    },
    {
      label: 'Private List',
      value: 'PrivateList',
      permission: 'sanctions-configuration',
    },
    {
      label: 'Sanctions',
      value: 'Sanctions',
      permission: 'rule-engine',
      child: 'sanction',
    },
    {
      label: 'AMS',
      value: 'AMS',
      permission: 'rule-engine',
      child: 'ams',
    },
    {
      label: 'PEP',
      value: 'PEP',
      permission: 'rule-engine',
      child: 'pep',
    },
    {
      label: 'Transaction Parameter',
      value: 'TransactionParameter',
      permission: 'rule-engine',
      child: 'transaction-screening',
    },
    {
      label: 'Access Management',
      value: 'access_management',
      permission: 'access-management',
    },
    {
      label: 'Risk Rating',
      value: 'RiskRating',
      permission: 'rule-engine',
      child: 'risk-rating',
    },
    {
      label: 'Suppression Logic',
      value: 'SuppressionLogic',
      permission: 'suppression-logic',
    },
  ],
  riskRatingData: [
    {
      label: 'Risk Parameter',
      value: 'RiskParameter',
    },
    {
      label: 'Re-Kyc Configuration',
      value: 'ReKYCConfiguration',
    },
    {
      label: 'Individual Parameters Configuration',
      value: 'IndividualParametersConfiguration',
    },
    {
      label: 'Individual Parameters Weightage',
      value: 'IndividualParametersWeightage',
    },
    {
      label: 'Entity Parameters Configuration',
      value: 'EntityParametersConfiguration',
    },
    {
      label: 'Entity Parameters Weightage',
      value: 'EntityParametersWeightage',
    },
  ],
  accessManagementData: [
    { label: 'User', value: 'user' },
    { label: 'Groups', value: 'groups' },
    { label: 'Teams', value: 'teams' },
  ],
};
const INDIVIDUAL_DEDUPE_PARAMETER = [
  { value: 'pan', label: 'PAN' },
  { value: 'national_id', label: 'National ID' },
  { value: 'passport_number', label: 'Passport Number' },
  { value: 'voters_id', label: "Voter's ID" },
  { value: 'drivers_license', label: 'Driving License' },
  { value: 'phone_number', label: 'Phone No' },
  { value: 'ssn', label: 'SSN' },
  { value: 'date_of_birth', label: 'Date Of Birth' },
  { value: 'application_id', label: 'Application ID' },
  { value: 'applicant_id', label: 'Applicant ID' },
  { value: 'email', label: 'Email ID' },
];
const AIRCRAFT_DEDUPE_PARAMETER = [
  { value: 'manufacture_serial_number', label: 'MSN' },
  { value: 'construction_number', label: 'Construction No.' },
  { value: 'date_of_birth', label: 'Aircraft Manufacture Date' },
  { value: 'aircraft_model', label: 'Aircraft Model' },
];

const VESSEL_DEDUPE_PARAMETER = [
  { value: 'imo', label: 'IMO No.' },
  { value: 'mmsi', label: 'MMSI No.' },
  { value: 'date_of_birth', label: 'Vessel Manufacture Date' },
];

const ENTITY_DEDUPE_PARAMETER = [
  { value: 'tin', label: 'TIN' },
  { value: 'isin', label: 'ISIN' },
  { value: 'cin', label: 'CIN' },
  { value: 'gst', label: 'GST' },
  { value: 'email', label: 'Email ID' },
  { value: 'date_of_birth', label: 'Date Of Establishment' },
  { value: 'application_id', label: 'Application ID' },
  { value: 'applicant_id', label: 'Applicant ID' },
];
const DEFAULT_DEDUPE_PARAMETER = [
  // Individual parameters
  { value: 'pan', label: 'PAN' },
  { value: 'national_id', label: 'National ID' },
  { value: 'passport_number', label: 'Passport Number' },
  { value: 'voters_id', label: "Voter's ID" },
  { value: 'drivers_license', label: 'Driving License' },
  { value: 'phone_number', label: 'Phone No' },
  { value: 'ssn', label: 'SSN' },

  // Common parameters
  { value: 'date_of_birth', label: 'DOB/DOE/DOM' },
  { value: 'email', label: 'Email ID' },
  { value: 'application_id', label: 'Application ID' },
  { value: 'applicant_id', label: 'Applicant ID' },

  // Entity parameters
  { value: 'tin', label: 'TIN' },
  { value: 'isin', label: 'ISIN' },
  { value: 'cin', label: 'CIN' },
  { value: 'gst', label: 'GST' },

  // Vessel parameters
  { value: 'imo', label: 'IMO No.' },
  { value: 'mmsi', label: 'MMSI No.' },

  // Aircraft parameters
  { value: 'manufacture_serial_number', label: 'MSN' },
  { value: 'construction_number', label: 'Construction No.' },
  { value: 'aircraft_model', label: 'Aircraft Model' },
];

const RISK_RATING_MENU_ITEMS = {
  individual: [
    { value: 'age', label: 'Age' },
    { value: 'occupation', label: 'Occupation' },
    { value: 'income', label: 'Income' },
    { value: 'sanctions', label: 'Sanctions' },
    { value: 'pep', label: 'PEP' },
    { value: 'ams', label: 'AMS' },
    { value: 'country', label: 'Country' },
    { value: 'product', label: 'Product type' },
    { value: 'onboarding_duration', label: 'Onboarding Duration' },
    { value: 'onboarding_type', label: 'Onboarding Type' },
    { value: 'missed_payment', label: 'Missed Payment' },
    { value: 'address', label: 'Address' },
    { value: 'nationality', label: 'Nationality' },
    { value: 'zipcode', label: 'Zipcode' },
  ],
  entity: [
    { value: 'incorporation', label: 'Incorporation Period' },
    { value: 'industry', label: 'Industry Type' },
    { value: 'income', label: 'Income' },
    { value: 'sanctions', label: 'Sanctions' },
    { value: 'ams', label: 'AMS' },
    { value: 'pep', label: 'PEP' },
    { value: 'country', label: 'Country' },
    { value: 'product', label: 'Product type' },
    { value: 'onboarding_duration', label: 'Onboarding Duration' },
    { value: 'onboarding_type', label: 'Onboarding Type' },
    { value: 'address', label: 'Address' },
    { value: 'nationality', label: 'Nationality' },
    { value: 'zipcode', label: 'Zipcode' },
    { value: 'missed_payment', label: 'Missed Payment' },
  ],
};

const UNSAVED_CHANGES_MESSAGE =
  'Please submit your changes before leaving this page to avoid losing them.';
const RISK_RATING_CONTINOUS_STATIC_PARAMETERS = [
  'age',
  'income',
  'onboarding_duration',
  'incorporation',
  'missed_payment',
];
const RISK_RATING_STATIC_PARAMETERS = [
  'age',
  'income',
  'onboarding_duration',
  'incorporation',
  'missed_payment',
  'occupation',
  'country',
  'industry',
  'product',
  'zipcode',
  'address',
  'nationality',
  'onboarding_type',
];
const bulkColumns = [
  'Name',
  'Full Name',
  'Org Name',
  'Vessel Name',
  'Aircraft Name',
  'Transaction ID',
];
const GLOBAL_DATE_FORMAT = 'YYYY-MM-DD';
const DISPLAY_DATE_FORMAT = 'MMM DD, YYYY';
const GLOBAL_DATE_TIME_FORMAT = 'hh:mm A';
const GLOBAL_DATE_FORMAT_WITH_TIME = 'YYYY-MM-DD HH:mm:ss';
const GLOBAL_SEPARATOR = '$**$';
const FIELD_TYPES = Array.from({ length: 20 }, (_, i) => `field${i + 1}`);
const FILTER_TYPE_MULTI = 'multi';
export const FILTER_DATA_TYPES = {
  SINGLESELECT: 'singleselect',
  MULTISELECT: 'multiselect',
  DATE: 'Date',
  RANGE: 'Range',
  TEXTFIELD: 'textfield',
};
const PERMISSION_CATEGORIES = {
  MANAGER_SETUP: 'Manager Setup Permissions',
  INITIATE_SEARCH: 'Initiate Search Permissions',
  INITIAL_SCREENING: 'Initial Screening Permissions',
  ONGOING_MONITORING: 'Ongoing Monitoring Permissions',
  DOWNLOAD: 'Download Permissions',
  HISTORY: 'History Permissions',
  DASHBOARD: 'Dashboard Permissions',
  RISK_RATING: 'Risk Rating Permissions',
  TTR: 'TTR Permissions',
  REFERRAL: 'Referrals Permissions',
  LEGAL: 'Legal Permissions',
  CORPORATE: 'Corporate Permissions',
  COSTING: 'Costing Permissions',
  BAG_OF_WORDS: 'Bag Of Words Permissionss',
};
const PERMISSION_SUBCATEGORIES = {
  SANCTION_CONFIGURATION: 'sanctions-configuration',
  ACCESS_MANAGEMENT: 'access-management',
  RULE_ENGINE: 'rule-engine',
  INITIATE: 'initiate',
  INITIAL_SCREENING: 'initial-screening',
  ONGOING_MONITORING: 'ongoing-screening',
  DOWNLOAD: 'download',
  TTR: 'ttr',
  REFERRALS: 'referrals',
};
const PERMISSION_CODES = {
  GLOBAL_SANCTION_LIST: 'global-sanction-list',
  PRIVATE_SANCTION_LIST: 'private-sanction-list',
  USERS: 'users',
  CHANGE_ANALYST_STATUS: 'change-analyst-status',
  TEAMS: 'teams',
  GROUPS: 'groups',
  AMS: 'ams',
  PEP: 'pep',
  SANCTION: 'sanction',
  RISK_RATING: 'risk-rating',
  TRANSACTION_SCREENING: 'transaction-screening',
  SUPPRESSION_LOGIC: 'suppression-logic',
  EXCLUSION_LIST: 'exclusion-list',
  AUDIT_HISTORY: 'audit-history',
  STR: 'str',
  UPLOAD_SEARCHES: 'upload-searches',
  INITIATE_INITIAL: 'initiate-initial',
  INITIATE_ONGOING: 'initiate-ongoing',
  ASSIGN_SEARCHES: 'assign-searches',
  INITIAL_MY_QUEUE: 'initial-my-queue',
  INITIAL_COMMON_QUEUE: 'initial-common-queue',
  INITIAL_BULK_VERDICT: 'initial-bulk-verdict',
  INITIAL_TRANSFERRED_SEARCHES_HISTORY: 'initial-transferred_searches_history',
  INITIAL_ASSIGN_TO_OTHERS: 'initial-assign-to-others',
  ONGOING_MY_QUEUE: 'ongoing-my-queue',
  ONGOING_COMMON_QUEUE: 'ongoing-common-queue',
  ONGOING_BULK_VERDICT: 'ongoing-bulk-verdict',
  ONGOING_TRANSFERRED_SEARCHES_HISTORY: 'ongoing-transferred_searches_history',
  ONGOING_ASSIGN_TO_OTHERS: 'ongoing-assign-to-others',
  DOWNLOAD_REPORT: 'download-report',
  DOWNLOAD_STATUS: 'download-status',
  HISTORY: 'history',
  CUSTOMIZED_DASHBOARD: 'customized-dashboard',
  ANALYST_DASHBOARD: 'analyst-dashboard',
  MANAGER_DASHBOARD: 'manager-dashboard',
  ADMIN_DASHBOARD: 'admin-dashboard',
  RISK_RATING_DASHBOARD: 'risk-rating-dashboard',
  EDIT_RISK_RATING: 'edit-risk-rating',
  UPLOAD_FILE: 'upload-file',
  DOWNLOAD_XML_FILE: 'download-xml-files',
  CAPITAL_MARKET: 'capital-market',
  INSURANCE: 'insurance',
  RIGHT_SHARE: 'right-share',
  PENDING_REFERRALS: 'pending-referrals',
  COMPLETED_REFERRALS: 'completed-referrals',
  WEB_BASED_AMS: 'web-based-ams',
  AMS_CRAWLER: 'ams-crawler',
  REAL_TIME_CRAWLER: 'real-time-crawler',
  TRUSTED_SOURCES: 'trusted-sources',
  BAIDU_SEARCH: 'baidu-search',
  GOOGLE_SEARCH: 'google-search',
  LEGAL: 'legal',
  CORPORATE: 'corporate',
  COSTING: 'costing',
  BAG_OF_WORDS: 'bag-of-words',
  MANAGER_SETUP: 'manager-setup',
  MULTIPLE_RULES: 'multiple-rules',
  IP_WHITELISTING: 'ip-whitelisting',
};

const PERMISSION_TYPES = {
  VIEW: 'VIEW',
  EDIT: 'EDIT',
  NONE: 'NONE',
  CUSTOM: 'CUSTOM',
};
export const RATING_COLORS = {
  low: '#00b050',
  moderately_low: '#92d050',
  medium: '#ffcc00',
  moderately_high: '#ff7300ff',
  high: '#ff0000',
};
export const RATING_ICONS = {
  high: WarningLogoRed,
  moderately_high: WarningLogoModerateHigh,
  medium: WarningLogoYellow,
  low: WarningLogoGreen,
  moderately_low: WarningLogoModerateLow,
};
export const RATING_HOVER_COLORS = {
  low: '#009944',
  moderately_low: '#7ab844',
  medium: '#d9a800',
  moderately_high: '#d96200',
  high: '#cc0000',
};
export const ratingsConfig = {
  low: {
    id: 0,
    label: 'low',
    isDefault: true,
  },
  moderately_low: {
    id: 0,
    label: 'moderately_low',
    isDefault: false,
  },
  medium: {
    id: 1,
    label: 'medium',
    isDefault: true,
  },
  moderately_high: {
    id: 1,
    label: 'moderately_high',
    isDefault: false,
  },
  high: {
    id: 2,
    label: 'high',
    isDefault: true,
  },
};

const alertListTypes = [
  'sanction_count',
  'sanction_country_count',
  'pep_count',
  'ams_count',
  'legal_count',
  'corporate_count',
];

// Boolean alert field names for transaction screening
const ALERT_FIELD_TYPES = [
  'sanction_alert',
  'sanction_country_alert',
  'pep_alert',
  'ams_alert',
  'legal_alert',
  'corporate_alert',
];

const TRUE_MATCH_OPTIONS = [
  'sanction_true_match',
  'pep_true_match',
  'ams_true_match',
];

export const LEGACY_COLUMN_MAPPING = {
  'D.O.B (yyyy/mm/dd)': 'D.O.B (yyyy-mm-dd)',
  'D.O.E (yyyy/mm/dd)': 'D.O.E (yyyy-mm-dd)',
  'Mfd date (yyyy/mm/dd)': 'Mfd date (yyyy-mm-dd)',
  'Mfd Date (yyyy/mm/dd)': 'Mfd Date (yyyy-mm-dd)',
  'DOB/DOM/DOE(yyyy/mm/dd)': 'DOB/DOM/DOE(yyyy-mm-dd)',
  'Transaction Date': 'Transaction Date (yyyy-mm-dd)',
  'Ongoing Monitoring End date': 'Ongoing Monitoring End date (yyyy-mm-dd)',
};
const OTHER_FIELDS_COUNT = 20;

const INITIAL_SCREENING_ORDER = (key) => [
  `${key}-my-queue`,
  `${key}-common-queue`,
  `${key}-transferred_searches_history`,
];

const REFERRAL_ORDER = ['pending-referrals', 'completed-referrals'];

const DEFAULT_COLUMNS = [
  'search_id',
  'status',
  'search_type',
  'name',
  'aliases',
  'date_of_birth',
  'review_id',
  'pan',
  'address',
  'timestamp',
];

const TRANSACTION_SCREENING_ISO_COLUMNS = [
  'FIToFICstmrCdtTrf',
  'MsgId',
  'CreDtTm',
  'NbOfTxs',
  'CtrlSum',
  'SttlmInf',
  'InstgAgt/BICFI',
  'InstgAgt/Nm',
  'InstdAgt/BICFI',
  'InstdAgt/Nm',
  'InstrId',
  'EndToEndId',
  'TxId',
  'UETR',
  'SvcLvl/Cd',
  'ClrChanl',
  'IntrBkSttlmAmt (Ccy)',
  'IntrBkSttlmAmt',
  'InstdAmt (Ccy)',
  'InstdAmt',
  'ChrgBr',
  'ChrgsInf/Amt (Ccy)',
  'ChrgsInf/Amt',
  'ChrgsInf/Agt/FinInstnId/BICFI',
  'ChrgsInf/Agt/FinInstnId/Nm',
  'UltmtDbtr/Nm',
  'UltmtDbtr/LEI',
  'UltmtDbtr/StrtNm',
  'UltmtDbtr/TwnNm',
  'UltmtDbtr/PstCd',
  'UltmtDbtr/Ctry',
  'Dbtr/Nm',
  'Dbtr/BirthDt',
  'Dbtr/CityOfBirth',
  'Dbtr/CtryOfBirth',
  'Dbtr/PrvtId/Othr/Id',
  'Dbtr/StrtNm',
  'Dbtr/TwnNm',
  'Dbtr/PstCd',
  'Dbtr/Ctry',
  'DbtrAcct/Id/Othr/Id',
  'Dbtr/SchmeNm/Prtry',
  'DbtrAcct/Nm',
  'DbtrAgt/FinInstnId/BICFI',
  'DbtrAgt/FinInstnId/Nm',
  'DbtrAgt/FinInstnId/LEI',
  'IntrmyAgt1/FinInstnId/BICFI',
  'IntrmyAgt1/FinInstnId/Nm',
  'IntrmyAgt2/FinInstnId/BICFI',
  'IntrmyAgt2/FinInstnId/Nm',
  'CdtrAgt/FinInstnId/BICFI',
  'CdtrAgt/FinInstnId/Nm',
  'Cdtr/Nm',
  'Cdtr/PstlAdr/StrtNm',
  'Cdtr/PstlAdr/TwnNm',
  'Cdtr/PstlAdr/PstCd',
  'Cdtr/PstlAdr/Ctry',
  'Cdtr/Id/PrvtId/DtAndPlcOfBirth/BirthDt',
  'Cdtr/Id/PrvtId/DtAndPlcOfBirth/CityOfBirth',
  'Cdtr/Id/PrvtId/DtAndPlcOfBirth/CtryOfBirth',
  'Cdtr/Id/PrvtId/Othr/Id',
  'CdtrAcct/Id/IBAN',
  'CdtrAcct/Nm',
  'Ustrd',
  'DbtCdtRptgInd',
  'Authrty/Nm',
  'Authrty/Ctry',
  'PlcAndNm',
  'Ifsc',
  'LocalRouting',
];

const PARTY_MAPPINGS = {
  payer: ['payer_details', 'debtor_details'],
  recipient: ['recipient_details', 'creditor_details'],
  payer_bank: ['payer_bank_details', 'debtor_agent_details'],
  recipient_bank: ['recipient_bank_details', 'creditor_agent_details'],
};

const DETAILS_COLUMN_PREFIXES = [
  'payer_details',
  'recipient_details',
  'debtor_details',
  'creditor_details',
];

const EXCLUDED_FIELDS_TRANSACTION_ALERTS = [
  'search_id',
  'batch_id',
  'party',
  'created_by',
  'alerted',
  'verdict_count',
  'risk_rating',
  'bookmark',
  'review_id',
  'updated_time',
  'assigned_to',
  'pending_referral_id',
  'is_transaction_excluded',
  'mnrl_count',
  'initiated_by_username',
  'initiated_by_fullname',
  'verdicts',
  'risk_rating_result',
  'sanction_count',
  'pep_count',
  'ams_count',
  'legal_count',
  'corporate_count',
  'sanction_country_count',
  'sanction_alert',
  'pep_alert',
  'ams_alert',
  'legal_alert',
  'corporate_alert',
  'sanction_country_alert',
  'risk_rating_alert',
  'sanction_field',
  'pep_field',
  'ams_field',
  'legal_field',
  'corporate_field',
  'sanction_country_field',
  'risk_rating_field',
  'crr_custom_fields',
  'other_fields',
  'search_type',
  'id',
  'team',
  'sub_team',
];

const ALERT_TYPE_LABELS = {
  sanction_count: 'Sanctions',
  sanction_country_count: 'Sanctions',
  ams_count: 'AMS',
  pep_count: 'PEP',
  legal_count: 'Legal',
  corporate_count: 'Corporate',
};

const ALERT_TYPE_MAP = {
  sanctionList: ['sanction_count', 'sanction_country_count', 'mnrl_count'],
  pepList: ['pep_count'],
  amsList: ['ams_count'],
  addonList: ['legal_count', 'corporate_count'],
};
const MAX_LENGTH = 100;
const DEFAULT_ADMIN_NAME = 'Solytics Admin';
export const FILTER_EMPTY_STATE_LABELS = {
  noOptions: 'No Option Available',
  noSearchResults: 'No Match Found',
};

export const SEARCH_LABELS = {
  transactionScreenLabel: 'Search By Transaction ID',
  nameScreenLabel: 'Search By Name, Search ID, Applicant ID, Application ID',
};

// Demo Constants
export const bankDetails = [
  {
    bank_name: 'Emirates NBD',
    bank_identifier_code: '',
    bank_address: '',
    bank_city: 'Dubai',
    bank_state: '',
    bank_country: 'UAE',
  },
  {
    bank_name: 'Alfa-Bank',
    bank_identifier_code: '',
    bank_address: '',
    bank_city: 'Moscow',
    bank_state: '',
    bank_country: 'Russia',
  },
];

// Name matches the backend field-path convention used at every call site
// (e.g. name="goods_details.goods_name"); renaming would require touching
// dozens of call sites across 5 files.
// eslint-disable-next-line camelcase
export const goods_details = {
  goods_name: 'Industrial Valves',
  unit_of_measure: 'Kilograms',
  country_of_origin: 'Egypt',
  qunatity: 100,
  hsn_code: '8481',
  goods_description: 'Industrial Valves',
};

// Name used at import sites across useInitialScreening.js/
// useOngoingScreening.js; renaming needs a wider, unrelated change.
// eslint-disable-next-line camelcase
export const Dummy_PEP_DATA = {
  'Petr Olegovich AVEN': {
    comments: [
      'Confirmed as a true positive based on strong alignment across key identity attributes. The screened party’s name matches the listed individual, the date of birth matches exactly, and the partial address similarity provides additional supporting evidence indicating a high probability of identity match.',
      'Confirmed as a true positive based on strong alignment across key identity attributes. The screened party’s name matches the listed individual, the date of birth matches exactly, and the partial address similarity provides additional supporting evidence indicating a high probability of identity match.',
      'Confirmed as a true positive based on strong alignment across key identity attributes. The screened party’s name matches the listed individual, the date of birth matches exactly, and the partial address similarity provides additional supporting evidence indicating a high probability of identity match.',
      'Confirmed as a false positive due to mismatched identity attributes. Although the screened party name shows similarity with the listed individual, the date of birth and address information do not match. The discrepancies across key identifiers indicate that the screened party is not the same individual as the listed subject.',
      'Confirmed as a false positive due to mismatched identity attributes. Although the screened party name shows similarity with the listed individual, the date of birth and address information do not match. The discrepancies across key identifiers indicate that the screened party is not the same individual as the listed subject.',
    ],
    status: ['selected', 'selected', 'selected', 'notSelected', 'notSelected'],
  },
  'ABDALLA Ahmed': {
    comments: [
      'Confirmed as a false positive due to mismatched identity attributes. Although the screened party name shows similarity with the listed individual, the match is limited to partial name similarity with missing matching tokens/segments. Additionally, the date of birth and address information do not align with the listed record. The combination of missing name tokens and conflicting identifiers indicates that the screened party is not the same individual as the listed subject.',
      'Confirmed as a false positive due to mismatched identity attributes. Although the screened party name shows similarity with the listed individual, the match is limited to partial name similarity with missing matching tokens/segments. Additionally, the date of birth and address information do not align with the listed record. The combination of missing name tokens and conflicting identifiers indicates that the screened party is not the same individual as the listed subject.',
      'Confirmed as a false positive due to mismatched identity attributes. Although the screened party name shows similarity with the listed individual, the match is limited to partial name similarity with missing matching tokens/segments. Additionally, the date of birth and address information do not align with the listed record. The combination of missing name tokens and conflicting identifiers indicates that the screened party is not the same individual as the listed subject.',
      'Confirmed as a false positive due to mismatched identity attributes. Although the screened party name shows similarity with the listed individual, the match is limited to partial name similarity with missing matching tokens/segments. Additionally, the date of birth and address information do not align with the listed record. The combination of missing name tokens and conflicting identifiers indicates that the screened party is not the same individual as the listed subject.',
      'Confirmed as a false positive due to mismatched identity attributes. Although the screened party name shows similarity with the listed individual, the match is limited to partial name similarity with missing matching tokens/segments. Additionally, the date of birth and address information do not align with the listed record. The combination of missing name tokens and conflicting identifiers indicates that the screened party is not the same individual as the listed subject.',
      'Confirmed as a false positive due to mismatched identity attributes. Although the screened party name shows similarity with the listed individual, the match is limited to partial name similarity with missing matching tokens/segments. Additionally, the date of birth and address information do not align with the listed record. The combination of missing name tokens and conflicting identifiers indicates that the screened party is not the same individual as the listed subject.',
      'Confirmed as a false positive due to mismatched identity attributes. Although the screened party name shows similarity with the listed individual, the match is limited to partial name similarity with missing matching tokens/segments. Additionally, the date of birth and address information do not align with the listed record. The combination of missing name tokens and conflicting identifiers indicates that the screened party is not the same individual as the listed subject.',
      'Confirmed as a false positive due to mismatched identity attributes. Although the screened party name shows similarity with the listed individual, the match is limited to partial name similarity with missing matching tokens/segments. Additionally, the date of birth and address information do not align with the listed record. The combination of missing name tokens and conflicting identifiers indicates that the screened party is not the same individual as the listed subject.',
      'Confirmed as a false positive due to mismatched identity attributes. Although the screened party name shows similarity with the listed individual, the match is limited to partial name similarity with missing matching tokens/segments. Additionally, the date of birth and address information do not align with the listed record. The combination of missing name tokens and conflicting identifiers indicates that the screened party is not the same individual as the listed subject.',
      'Confirmed as a false positive due to mismatched identity attributes. Although the screened party name shows similarity with the listed individual, the match is limited to partial name similarity with missing matching tokens/segments. Additionally, the date of birth and address information do not align with the listed record. The combination of missing name tokens and conflicting identifiers indicates that the screened party is not the same individual as the listed subject.',
    ],
    status: [
      'notSelected',
      'notSelected',
      'notSelected',
      'notSelected',
      'notSelected',
      'notSelected',
      'notSelected',
      'notSelected',
      'notSelected',
      'notSelected',
    ],
  },
};
// Name used at import sites across useInitialScreening.js/
// useOngoingScreening.js; renaming needs a wider, unrelated change.
// eslint-disable-next-line camelcase
export const Dummy_SANCTION_DATA = {
  'Petr Olegovich AVEN': {
    comments: [
      'Confirmed as a true positive based on strong alignment across key identity attributes. The screened party’s name matches the listed individual, the date of birth matches exactly, and the partial address similarity provides additional supporting evidence indicating a high probability of identity match.',
      'Confirmed as a false positive due to mismatched identity attributes. Although the screened party name shows similarity with the listed individual, the match is limited to partial name similarity with missing matching tokens/segments.',
      'Confirmed as a false positive due to mismatched identity attributes. Although the screened party name shows similarity with the listed individual, the match is limited to partial name similarity with missing matching tokens/segments.',
      'Confirmed as a false positive due to mismatched identity attributes. Although the screened party name shows similarity with the listed individual, the match is limited to partial name similarity with missing matching tokens/segments. Additionally, address information do not align with the listed record .',
      'Confirmed as a false positive due to mismatched identity attributes. Although the screened party name shows similarity with the listed individual, the match is limited to partial name similarity with missing matching tokens/segments. Additionally, the date of birth and address information do not align with the listed record. The combination of missing name tokens and conflicting identifiers indicates that the screened party is not the same individual as the listed subject.',
      'Confirmed as a false positive due to mismatched identity attributes. Although the screened party name shows similarity with the listed individual, the match is limited to partial name similarity with missing matching tokens/segments. Additionally, the date of birth and address information do not align with the listed record. The combination of missing name tokens and conflicting identifiers indicates that the screened party is not the same individual as the listed subject.',
      'Confirmed as a false positive due to mismatched identity attributes. Although the screened party name shows similarity with the listed individual, the match is limited to partial name similarity with missing matching tokens/segments. Additionally, the date of birth and address information do not align with the listed record. The combination of missing name tokens and conflicting identifiers indicates that the screened party is not the same individual as the listed subject.',
    ],
    status: [
      'selected',
      'notSelected',
      'notSelected',
      'notSelected',
      'notSelected',
      'notSelected',
      'notSelected',
    ],
  },
  'ABDALLA Ahmed': {
    comments: [
      'Confirmed as a true positive based on strong alignment across key identity attributes. The screened party’s name matches the listed individual, the date of birth matches exactly, and the partial address similarity provides additional supporting evidence indicating a high probability of identity match.',
      'Confirmed as a false positive based on insufficient matching evidence. The screened party name shows similarity with the listed individual; however, key identifying information such as date of birth and country details are unavailable for validation. In the absence of supporting identifiers, the match cannot be confirmed and is recommended for closure as a false positive.',
      'Confirmed as a false positive based on insufficient identity correlation. Although the screened party name is similar to the listed individual, the date of birth information is unavailable and the country associated with the address does not match. The lack of supporting identifiers and conflicting geographic information indicates that the screened party is unlikely to be the listed individual.',
      'Confirmed as a false positive based on insufficient identity correlation. Although the screened party name is similar to the listed individual, the date of birth information is unavailable and the country associated with the address does not match. The lack of supporting identifiers and conflicting geographic information indicates that the screened party is unlikely to be the listed individual.',
      'Confirmed as a false positive based on insufficient identity correlation. Although the screened party name is similar to the listed individual, the date of birth information and the country associated with the address does not match. The lack of supporting identifiers and conflicting geographic information indicates that the screened party is unlikely to be the listed individual.',
      'Confirmed as a false positive due to mismatched identity attributes. Although the screened party name shows similarity with the listed individual, the date of birth and address information do not match. The discrepancies across key identifiers indicate that the screened party is not the same individual as the listed subject.',
      'Confirmed as a false positive due to mismatched identity attributes. Although the screened party name shows similarity with the listed individual, the date of birth and address information do not match. The discrepancies across key identifiers indicate that the screened party is not the same individual as the listed subject.',
      'Confirmed as a false positive due to mismatched identity attributes. Although the screened party name shows similarity with the listed individual, the match is limited to partial name similarity with missing matching tokens/segments. Additionally, the date of birth and address information do not align with the listed record. The combination of missing name tokens and conflicting identifiers indicates that the screened party is not the same individual as the listed subject.',
      'Confirmed as a false positive due to mismatched identity attributes. Although the screened party name shows similarity with the listed individual, the match is limited to partial name similarity with missing matching tokens/segments. Additionally, the date of birth and address information do not align with the listed record. The combination of missing name tokens and conflicting identifiers indicates that the screened party is not the same individual as the listed subject.',
      'Confirmed as a false positive due to mismatched identity attributes. Although the screened party name shows similarity with the listed individual, the match is limited to partial name similarity with missing matching tokens/segments. Additionally, the date of birth and address information do not align with the listed record. The combination of missing name tokens and conflicting identifiers indicates that the screened party is not the same individual as the listed subject.',
    ],
    status: [
      'selected',
      'notSelected',
      'notSelected',
      'notSelected',
      'notSelected',
      'notSelected',
      'notSelected',
      'notSelected',
      'notSelected',
      'notSelected',
    ],
  },
};
// Name used at import sites across useInitialScreening.js/
// useOngoingScreening.js; renaming needs a wider, unrelated change.
// eslint-disable-next-line camelcase
export const Dummy_AMS_DATA = {
  'ABDALLA Ahmed': {
    comments: [
      'Confirmed as a false positive due to mismatched identity attributes. Although the screened party name shows similarity with the listed individual, the match is limited to partial name similarity with missing matching tokens/segments.',
      'Confirmed as a false positive due to mismatched identity attributes. Although the screened party name shows similarity with the listed individual, the match is limited to partial name similarity with missing matching tokens/segments.',
      'Confirmed as a false positive due to mismatched identity attributes. Although the screened party name shows similarity with the listed individual, the match is limited to partial name similarity with missing matching tokens/segments.',
      'Confirmed as a false positive due to mismatched identity attributes. Although the screened party name shows similarity with the listed individual, the match is limited to partial name similarity with missing matching tokens/segments.',
      'Confirmed as a false positive due to mismatched identity attributes. Although the screened party name shows similarity with the listed individual, the match is limited to partial name similarity with missing matching tokens/segments.',
      'Confirmed as a false positive due to mismatched identity attributes. Although the screened party name shows similarity with the listed individual, the match is limited to partial name similarity with missing matching tokens/segments.',
      'Confirmed as a false positive due to mismatched identity attributes. Although the screened party name shows similarity with the listed individual, the match is limited to partial name similarity with missing matching tokens/segments.',
      'Confirmed as a false positive due to mismatched identity attributes. Although the screened party name shows similarity with the listed individual, the match is limited to partial name similarity with missing matching tokens/segments.',
      'Confirmed as a false positive due to mismatched identity attributes. Although the screened party name shows similarity with the listed individual, the match is limited to partial name similarity with missing matching tokens/segments.',
      'Confirmed as a false positive due to mismatched identity attributes. Although the screened party name shows similarity with the listed individual, the match is limited to partial name similarity with missing matching tokens/segments.',
    ],
    status: [
      'notSelected',
      'notSelected',
      'notSelected',
      'notSelected',
      'notSelected',
      'notSelected',
      'notSelected',
      'notSelected',
      'notSelected',
      'notSelected',
    ],
  },
};

export const DEFAULT_COMMENT =
  'Confirmed as a false positive due to insufficient name match confidence. Although the screened party name shows similarity with the listed individual, the match contains missing name tokens/segments, resulting in an incomplete identity match. No additional supporting identifiers are available to establish a link with the listed subject; therefore, the alert is recommended for closure as a false positive.';

const FILE_FORMAT_OPTIONS = ['Standard', 'ISO', 'MT700'];

// Maps the user-facing File Format selection to the coded value the backend
// stores/filters on as `search_format`. `SAMS` is the bulk-upload dropdown's
// raw value for the same "Standard" option used by the single-search flow.
const SEARCH_FORMAT_TYPES = {
  Standard: 'TS-STD',
  SAMS: 'TS-STD',
  ISO: 'TS-ISO',
};

const SEARCH_FORMAT_OPTIONS = [
  { label: 'Standard', value: SEARCH_FORMAT_TYPES.Standard },
  { label: 'ISO', value: SEARCH_FORMAT_TYPES.ISO },
];

const MT700_FIELDS = [
  { code: '27', label: 'Sequence of Total', type: 'text' },
  { code: '40A', label: 'Form of Documentary Credit', type: 'text' },
  { code: '20', label: 'Documentary Credit Number', type: 'text' },
  { code: '23', label: 'Reference to Pre-Advice', type: 'text' },
  { code: '31C', label: 'Date of Issue', type: 'date' },
  { code: '40E', label: 'Applicable Rules', type: 'text' },
  { code: '31D', label: 'Date and Place of Expiry', type: 'date' },
  { code: '51A', label: 'Applicant Bank', type: 'text' },
  { code: '50', label: 'Applicant', type: 'text' },
  { code: '59', label: 'Beneficiary', type: 'text' },
  { code: '32B', label: 'Currency Code, Amount', type: 'text' },
  { code: '39A', label: 'Percentage Credit Amount Tolerance', type: 'text' },
  { code: '39C', label: 'Additional Amounts Covered', type: 'text' },
  { code: '41A', label: 'Available With...By...', type: 'text' },
  { code: '42C', label: 'Drafts at', type: 'text' },
  { code: '42A', label: 'Drawee', type: 'text' },
  { code: '42M', label: 'Mixed Payment Details', type: 'text' },
  { code: '42P', label: 'Negotiation/Deferred Payment Details', type: 'text' },
  { code: '43P', label: 'Partial Shipments', type: 'text' },
  { code: '43T', label: 'Transhipment', type: 'text' },
  { code: '44A', label: 'Place of Receipt', type: 'text' },
  { code: '44E', label: 'Port of Loading', type: 'text' },
  { code: '44F', label: 'Port of Discharge', type: 'text' },
  { code: '44B', label: 'Final Destination', type: 'text' },
  { code: '44C', label: 'Latest Date of Shipment', type: 'date' },
  { code: '44D', label: 'Shipment Period', type: 'text' },
  { code: '45A', label: 'Description of Goods/Services', type: 'text' },
  { code: '46A', label: 'Documents Required', type: 'text' },
  { code: '47A', label: 'Additional Conditions', type: 'text' },
  {
    code: '49G',
    label: 'Special Payment Conditions for Beneficiary',
    type: 'text',
  },
  {
    code: '49H',
    label: 'Special Payment Conditions for Receiving Bank',
    type: 'text',
  },
  { code: '71D', label: 'Charges', type: 'text' },
  { code: '48', label: 'Period for Presentation', type: 'text' },
  { code: '49', label: 'Confirmation Instructions', type: 'text' },
  { code: '58A', label: 'Requested Confirmation Party', type: 'text' },
  { code: '53A', label: 'Reimbursing Bank', type: 'text' },
  {
    code: '78',
    label: 'Instructions to Paying/Accepting/Negotiating Bank',
    type: 'text',
  },
  { code: '57A', label: 'Advise Through Bank', type: 'text' },
  { code: '72Z', label: 'Sender to Receiver Information', type: 'text' },
];

const constants = {
  WHITELISTED_IPS: 'whitelisted_ips',
  countries,
  days,
  marks,
  riskRatingMarks,
  reminderMailMarks,
  snoozingFrequencyMarks,
  dobMarks,
  SEARCH_TYPES,
  SEARCH_TYPES_TRANSACTION,
  SCREEN_TYPES,
  HISTORY_SCREEN_TYPES,
  ASSIGNED_OPTIONS,
  FINAL_VERDICTS,
  LIST_TYPES,
  BULK_FILE_LIST_TYPE_COLUMNS,
  BULK_FILE_RISK_LIST_TYPE_COLUMNS,
  PRIVATE_LIST_FILE_TYPE_COLUMNS,
  TTR_COLUMNS,
  alertListTypes,
  ALERT_FIELD_TYPES,
  alertBySamsMark,
  CURRENCIES,
  ADD_TO_EXCLUSION_COLUMNS,
  DATE_COLUMN_NAMES,
  AMS_NAME_COLUMNS,
  BULK_INITIAL_FILE_LIST_TYPE_COLUMNS,
  BULK_INITIAL_FILE_RISK_LIST_TYPE_COLUMNS,
  DATE_INITIAL_COLUMN_NAMES,
  ONBOARDING_TYPE,
  RISK_RATING_COLUMNS,
  ENTITY_DEDUPE_PARAMETER,
  VESSEL_DEDUPE_PARAMETER,
  AIRCRAFT_DEDUPE_PARAMETER,
  INDIVIDUAL_DEDUPE_PARAMETER,
  DEFAULT_DEDUPE_PARAMETER,
  TRANSACTION_SCREENING_COLUMNS,
  BULK_INITIAL_FILE_TRANSACTION_LIST_TYPE_COLUMNS,
  BULK_ONGOING_FILE_TRANSACTION_LIST_TYPE_COLUMNS,
  AUDIT_TRAIL_PARAMETERS,
  RISK_RATING_MENU_ITEMS,
  UNSAVED_CHANGES_MESSAGE,
  RISK_RATING_STATIC_PARAMETERS,
  RISK_RATING_CONTINOUS_STATIC_PARAMETERS,
  BULK_INITIAL_FILE_TRANSACTION_RISK_LIST_TYPE_COLUMNS,
  BULK_ONGOING_FILE_TRANSACTION_RISK_LIST_TYPE_COLUMNS,
  LEVELS,
  GLOBAL_DATE_FORMAT,
  DISPLAY_DATE_FORMAT,
  GLOBAL_DATE_TIME_FORMAT,
  GLOBAL_DATE_FORMAT_WITH_TIME,
  GLOBAL_SEPARATOR,
  FIELD_TYPES,
  FILTER_TYPE_MULTI,
  accountIds,
  FILTER_DATA_TYPES,
  bulkColumns,
  PERMISSION_CATEGORIES,
  PERMISSION_SUBCATEGORIES,
  PERMISSION_CODES,
  PERMISSION_TYPES,
  RATING_ICONS,
  TRUE_MATCH_OPTIONS,
  OTHER_FIELDS_COUNT,
  INITIAL_SCREENING_ORDER,
  REFERRAL_ORDER,
  INITIATE_SEARCH_FIELDS,
  AMS_TIMEFRAME_CONFIG: {
    DEFAULT_VALUE: 60,
    MIN_VALUE: 12,
    MAX_VALUE: 60,
    // Internal value used when "Include all years" checkbox is selected
    ALL_VALUE: -1,
    // Value sent to backend when "Include all years" is selected (configurable)
    BACKEND_ALL_VALUE: null,
    STEP: 1,
    MARKS: [
      { value: 12, label: '12' },
      { value: 24, label: '24' },
      { value: 36, label: '36' },
      { value: 48, label: '48' },
      { value: 60, label: '60' },
    ],
    TOOLTIP_TEXT:
      'Configure how far back the adverse media search should look for news articles.',
    LABEL: 'News Article Time Range (Months)',
    formatValueLabel: (value) => `${value}`,
    SELECTED_PREFIX: 'Selected: ',
    ALL_TIME_TEXT: 'All Time',
    MONTHS_SUFFIX: ' Months',
    CHECKBOX_LABEL: 'Show All Results',
  },
  AMS_UI_CONFIG: {
    MAX_VISIBLE_TAXONOMIES: 3,
  },
  RISK_RATING_DASHBOARD: {
    MAX_PARAMETERS: 10, // Maximum number of parameters that can be selected in the graph
  },
  SELECT_ALL_OPTION: {
    value: '__SELECT_ALL__',
    label: '— Select All —',
  },
  BATCH_FILE_PAGE_SIZE: 100,
  SEARCH_DEBOUNCE_DELAY_MS: 500,
  DEFAULT_COLUMNS,
  NO_DATA_AVAILABLE_OPTION: {
    value: 'no_data',
    label: 'No Data Available',
    disabled: true,
  },
  TRANSACTION_SCREENING_ISO_COLUMNS,
  PARTY_MAPPINGS,
  DETAILS_COLUMN_PREFIXES,
  EXCLUDED_FIELDS_TRANSACTION_ALERTS,
  ALERT_TYPE_LABELS,
  ALERT_TYPE_MAP,
  MAX_LENGTH,
  DEFAULT_ADMIN_NAME,
  FILTER_EMPTY_STATE_LABELS,
  FILE_FORMAT_OPTIONS,
  MT700_FIELDS,
  SEARCH_FORMAT_TYPES,
  SEARCH_FORMAT_OPTIONS,
};

export const ARRAY_FILTER_FIELDS = new Set([
  'searchType',
  'alertListType',
  'alerted',
  'alerts',
  'riskType',
  'horizontalTeam',
  'team',
  'analyst_id',
  'channel',
  'transaction_product_type',
  'party',
  'transaction_type',
  'onboarding_type',
  'occupation',
  'country',
  'product',
  'search_source',
  'field1',
  'searchStatus',
  'transferredTeam',
  'transferredUser',
  'transferType',
  'branch',
  'risk_type',
  'true_match',
  'manager',
  'analyst',
  'finalVerdict',
  'listType',
  'status',
  'search_type',
  'manager_id',
  'created_by_id',
  'pending_with',
  'risk_rating',
  'industry',
  'search_initiated',
  'batch_id',
]);

export default constants;
